export const ANIMAL_CATEGORY_GROUPS = [
  {
    id: "dogs",
    name: "الكلاب",
    subcategories: [
      "جولدن ريتريفر",
      "جيرمن شيبرد",
      "هاسكي",
      "روت وايلر",
      "لابرادور",
      "بيتبول",
      "دوبرمان",
      "شيواوا",
      "بودل",
      "بوميرانيان",
      "بولدوج",
      "بيجل",
      "كلاب أخرى",
    ],
  },
  {
    id: "cats",
    name: "القطط",
    subcategories: [
      "شيرازي",
      "بريتش",
      "سكوتش",
      "سيامي",
      "راغ دول",
      "مين كون",
      "بنغالي",
      "هيمالايا",
      "قطط أخرى",
    ],
  },
  {
    id: "birds",
    name: "الطيور",
    subcategories: [
      "ببغاء",
      "كناري",
      "بادجي",
      "كوكتيل",
      "حمام",
      "طيور الحب",
      "ببغاء أفريقي",
      "طيور أخرى",
    ],
  },
  {
    id: "fish",
    name: "أسماك الزينة",
    subcategories: [
      "أسماك زينة",
      "حوض أسماك",
      "معدات أحواض",
    ],
  },
  {
    id: "small-pets",
    name: "حيوانات صغيرة",
    subcategories: [
      "أرانب",
      "هامستر",
      "سلاحف",
      "زواحف",
      "حيوانات صغيرة أخرى",
    ],
  },
  {
    id: "pet-supplies",
    name: "مستلزمات الحيوانات",
    subcategories: [
      "طعام كلاب",
      "طعام قطط",
      "طعام طيور",
      "طعام حيوانات",
      "إكسسوارات حيوانات",
      "أقفاص",
      "بيوت حيوانات",
      "ألعاب حيوانات",
      "أطواق ومقاود",
    ],
  },
  {
    id: "pet-services",
    name: "خدمات الحيوانات",
    subcategories: [
      "تدريب كلاب",
      "حلاقة حيوانات",
      "فندقة حيوانات",
      "بيطري",
    ],
  },
] as const;

// === CATEGORIES (Arabic version) ===
export const CATEGORIES = {
  "emlak": {
    name: "العقارات",
    nameAr: "العقارات",
    nameEn: "Real Estate",
    nameTr: "Gayrimenkul",
    nameZh: "房地产",
    subcategories: [
      // سكني - للبيع
      "شقة للبيع", "فيلا للبيع", "منزل مستقل للبيع",
      "بيت ريفي للبيع", "مزرعة للبيع",
      // سكني - للإيجار
      "شقة للإيجار", "فيلا للإيجار", "منزل مستقل للإيجار",
      "إيجار يومي",
      // تجاري - للبيع
      "محل للبيع", "متجر للبيع", "مكتب للبيع", "طابق بلازا للبيع",
      "مصنع للبيع", "ورشة للبيع", "مستودع للبيع", "مطعم للبيع",
      "مقهى للبيع", "فندق للبيع", "شقق فندقية للبيع",
      // تجاري - للإيجار
      "محل للإيجار", "متجر للإيجار", "مكتب للإيجار", "طابق بلازا للإيجار",
      "مصنع للإيجار", "ورشة للإيجار", "مستودع للإيجار", "مطعم للإيجار",
      // أراضي
      "أرض سكنية للبيع", "أرض زراعية للبيع", "أرض تجارية للبيع",
      "حقل للبيع", "بستان للبيع", "أرض للإيجار", "أرض زراعية للإيجار",
      // أخرى
      "مشاريع سكنية", "منشأة سياحية", "مبنى"
    ]
  },
  "vasita": {
    name: "السيارات",
    nameAr: "السيارات",
    nameEn: "Vehicles",
    nameTr: "Araçlar",
    nameZh: "车辆",
    subcategories: [
      // سيارات
      "سيارة صالون", "دفع رباعي/SUV", "تكسي", "سيارة حمل", "بيك أب", "ستيشن واجن", "كوبيه (تك باب)", "كابريو (سيارة كشف)",
      // كهربائية
      "سيارات كهربائية", "سيارات هجينة (هايبرد)",
      // دراجات نارية
      "دراجة نارية", "سكوتر", "ATV", "دراجة كهربائية",
      // تجارية
      "فان", "باص صغير", "باص", "شاحنة (تريلة)", "شاحنة صغيرة (لوري)", "مقطورة",
      // أخرى
      "سيارات كلاسيكية", "سيارات متضررة", "سيارات للإيجار",
      "قوارب", "يخت", "جت سكي", "شراعي",
      "كرفان",
      "طائرات", "هليكوبتر"
    ]
  },
  "yedek-parca": {
    name: "قطع غيار السيارات",
    nameAr: "قطع غيار واكسسوارات السيارات",
    nameEn: "Spare Parts & Accessories",
    nameTr: "Yedek Parçalar ve Aksesuarlar",
    nameZh: "备件和配件",
    subcategories: [
      // قطع السيارات
      "قطع المحرك", "قطع ناقل الحركة", "نظام الفرامل", "نظام التعليق",
      "نظام العادم", "نظام التبريد", "نظام الوقود", "الأجزاء الكهربائية",
      "قطع الهيكل", "المرايا", "المصابيح", "الصدامات",
      // إطارات وجنوط
      "إطارات", "جنوط", "حساس ضغط الإطارات",
      // إكسسوارات
      "إكسسوارات السيارة", "أغطية المقاعد", "سجاد السيارة", "حوض الصندوق",
      "معطر السيارة", "حامل الهاتف",
      // إلكترونيات
      "أنظمة الصوت", "راديو", "مكبرات الصوت", "سب ووفر",
      "نظام الملاحة", "كاميرا السيارة", "حساس الركن", "كاميرا خلفية",
      // دراجات نارية
      "قطع غيار الدراجات", "إكسسوارات الدراجات", "خوذة", "جاكيت",
      "قفازات", "أحذية", "معدات الحماية",
      // منتجات الصيانة
      "زيت المحرك", "سائل التبريد", "زيت الفرامل", "سائل المساحات",
      "شامبو السيارة", "ملمع", "طقم صيانة"
    ]
  },
  "alisveris": {
    name: "التسوق",
    nameAr: "التسوق",
    nameEn: "Shopping",
    nameTr: "Alışveriş",
    nameZh: "购物",
    subcategories: [
      // الكمبيوتر
      "كمبيوتر", "لابتوب", "كمبيوتر مكتبي", "كمبيوتر ألعاب",
      "تابلت", "آيباد", "شاشة", "طابعة", "قطع الكمبيوتر",
      // الهواتف
      "هاتف محمول",
      "إكسسوارات الهاتف", "كفر", "شاحن", "سماعة بلوتوث",
      // إلكترونيات
      "تلفزيون", "سمارت تي في", "LED TV", "OLED TV",
      "أنظمة الصوت", "ساوند بار", "سماعات", "سماعات رأس",
      "كاميرا", "كاميرا احترافية", "عدسات",
      "كاميرا فيديو", "درون", "كاميرا أكشن",
      "بلايستيشن", "إكس بوكس", "نينتندو",
      // الأجهزة المنزلية
      "ثلاجة", "غسالة ملابس", "غسالة صحون", "مجففة",
      "فرن", "طباخ", "شفاط", "مايكروويف", "فريزر",
      "مكيف", "مكنسة كهربائية", "مكنسة روبوت",
      // أجهزة صغيرة
      "ماكينة قهوة", "غلاية شاي", "توستر", "خلاط",
      "مكواة", "مجفف شعر", "محمصة خبز", "كاتل",
      // ملابس نسائية
      "ملابس نسائية", "فساتين", "بلوزات", "قمصان", "تيشرتات",
      "بناطيل", "تنانير", "شورتات", "جواكت", "معاطف",
      "أحذية نسائية", "كعب عالي", "أحذية رياضية", "بوت", "صنادل",
      "حقائب نسائية", "شنط يد", "شنط كتف",
      // ملابس رجالية
      "ملابس رجالية", "قمصان رجالية", "تيشرتات رجالية", "بناطيل رجالية",
      "بدلات", "جواكت رجالية", "معاطف رجالية",
      "أحذية رجالية", "أحذية كلاسيك", "أحذية رياضية رجالية",
      // ملابس أطفال
      "ملابس أطفال", "ملابس رضع", "أحذية أطفال",
      // إكسسوارات
      "ساعات", "ساعات جدارية", "نظارات", "نظارات شمسية", "أحزمة", "محافظ", "أوشحة",
      // المنزل والأثاث
      "أثاث", "أثاث منزلي", "طقم كنب", "غرفة طعام", "غرفة نوم",
      "كنب", "طاولة", "كرسي", "دولاب", "مكتبة", "طاولة تلفزيون",
      "سرير", "قاعدة سرير", "مرتبة", "مفارش",
      "إضاءة", "ثريا", "لمبات", "أباجورة",
      "سجاد", "ستائر", "ديكور",
      "أدوات مطبخ", "قدور", "مقالي", "صحون", "أكواب",
      // الحديقة
      "أثاث حديقة", "أدوات الحديقة", "ماكينة قص العشب",
      // الرياضة
      "معدات رياضية", "أجهزة لياقة", "مشاية", "دراجة ثابتة",
      "دراجة هوائية", "دراجة جبلية", "دراجة كهربائية",
      "معدات تخييم", "خيمة", "كيس نوم",
      // الهوايات والفنون
      "آلات موسيقية", "جيتار", "بيانو", "أورج", "كمان", "درامز",
      "لوحات فنية", "تحف", "أنتيكات", "كتب", "ألعاب فيديو",
      // الأم والطفل
      "عربة أطفال", "سرير أطفال", "كرسي طعام", "كرسي سيارة",
      "مستلزمات الأطفال", "حفاضات", "رضاعات", "ألعاب",
      // مستحضرات التجميل
      "مستحضرات تجميل", "عطور", "مكياج", "العناية بالبشرة", "العناية بالشعر"
    ]
  },
  "aghziya": {
    name: "الأغذية",
    nameAr: "الأغذية",
    nameEn: "Food & Beverages",
    nameTr: "Gıda ve İçecekler",
    nameZh: "食品和饮料",
    subcategories: [
      // الحبوب والبقوليات
      "أرز", "قمح", "شعير", "عدس", "فاصولياء", "حمص", "فول", "ماش", "بازلاء",
      // الزيوت والدهون
      "زيت زيتون", "زيت نباتي", "زيت عباد الشمس", "زيت ذرة", "سمن", "زبدة",
      // التوابل والبهارات
      "توابل", "بهارات", "كركم", "فلفل أسود", "كمون", "زعفران", "قرفة", "هيل", "زنجبيل",
      // المعلبات والأغذية المحفوظة
      "معلبات", "طماطم معلبة", "تونة", "سردين", "ذرة معلبة", "فول معلب", "مخللات", "زيتون",
      // المشروبات
      "شاي", "قهوة", "قهوة تركية", "قهوة عربية", "نسكافيه", "عصائر", "مشروبات غازية", "مياه معدنية",
      // الألبان والأجبان
      "حليب", "لبن", "جبن", "قشطة", "زبادي", "حليب بودرة",
      // الحلويات والسكاكر
      "حلويات", "شوكولاتة", "بسكويت", "كيك", "حلويات شرقية", "بقلاوة", "معمول", "تمر",
      // المكسرات والفواكه المجففة
      "مكسرات", "فستق", "لوز", "جوز", "كاجو", "بندق", "زبيب", "تين مجفف", "مشمش مجفف",
      // الدقيق والمعجنات
      "دقيق", "طحين", "نشا", "خميرة", "معجنات", "خبز",
      // الصلصات والمواد الغذائية
      "صلصة طماطم", "كاتشب", "مايونيز", "خردل", "صويا صوص", "خل",
      // العسل والمربيات
      "عسل", "عسل طبيعي", "مربى", "دبس تمر", "دبس رمان", "طحينة",
      // اللحوم والدواجن (مجمدة ومصنعة)
      "لحوم مجمدة", "دجاج مجمد", "نقانق", "برغر", "لحوم مصنعة", "أسماك مجمدة",
      // الأغذية العالمية
      "أغذية تركية", "أغذية صينية", "أغذية هندية", "أغذية إيطالية", "أغذية كورية", "أغذية يابانية", "أغذية مكسيكية", "أغذية تايلندية",
      // أغذية صحية ومكملات
      "أغذية عضوية", "أغذية صحية", "أغذية خالية من الغلوتين", "مكملات غذائية", "بروتين", "شوفان",
      // أغذية الأطفال
      "حليب أطفال", "سيريلاك", "أغذية أطفال جاهزة",
      // مستلزمات المطاعم والمقاهي
      "مستلزمات مطاعم", "أكواب ورقية", "علب تغليف طعام", "أدوات بلاستيكية", "مناديل", "معدات مطاعم"
    ]
  },
  "riyada": {
    name: "الرياضة",
    nameAr: "الرياضة",
    nameEn: "Sports",
    nameTr: "Spor",
    nameZh: "体育",
    subcategories: [
      "أحذية رياضية", "أحذية كرة قدم", "أحذية جري", "أحذية كرة سلة",
      "ملابس رياضية", "ملابس تدريب", "ملابس سباحة", "ملابس رياضية نسائية", "ملابس رياضية رجالية", "ملابس رياضية أطفال",
      "حقائب رياضية", "حقائب ظهر رياضية", "حقائب سفر رياضية",
      "إكسسوارات رياضية", "ساعات رياضية", "نظارات رياضية", "قفازات رياضية", "أحزمة رياضية",
      "معدات كمال الأجسام", "أوزان حديدية", "بار حديد", "كيتل بل", "أغذية وبروتين",
      "معدات كرة القدم", "كرة قدم", "شبك مرمى",
      "معدات كرة السلة", "معدات تنس", "معدات سباحة",
      "دراجات هوائية رياضية", "إكسسوارات دراجات",
      "أخرى"
    ]
  },
  "atfal": {
    name: "الأطفال",
    nameAr: "الأطفال",
    nameEn: "Kids",
    nameTr: "Çocuklar",
    nameZh: "儿童",
    subcategories: [
      "ملابس أولاد", "ملابس بنات", "ملابس رضع (0-2 سنة)", "ملابس حديثي الولادة",
      "بيجامات أطفال", "ملابس داخلية أطفال", "ملابس سباحة أطفال", "أزياء تنكرية",
      "أحذية أولاد", "أحذية بنات", "أحذية رياضية أطفال", "صنادل أطفال", "أحذية رضع",
      "عربة أطفال", "كرسي سيارة أطفال", "سرير أطفال", "سرير رضع", "كرسي طعام أطفال",
      "حاملة أطفال (كاريير)", "مشاية أطفال", "حاجز أمان",
      "رضاعات", "حليب أطفال", "أغذية أطفال", "خلاط طعام أطفال", "أطباق وملاعق أطفال",
      "كرسي رضاعة", "وسادة رضاعة", "مضخة حليب",
      "حفاضات", "مناديل مبللة", "حقيبة حفاضات", "بانيو أطفال", "مستلزمات استحمام أطفال",
      "كريمات وعناية بالبشرة", "شامبو أطفال",
      "ألعاب تعليمية", "ألعاب أطفال رضع", "دمى ومجسمات", "ألعاب تركيب (ليغو)",
      "ألعاب إلكترونية أطفال", "ألعاب خارجية", "مراجيح وزحاليق", "مسابح أطفال",
      "ألعاب سيارات ودراجات أطفال", "دراجات أطفال",
      "حقائب مدرسية", "قرطاسية", "أدوات مدرسية", "كتب أطفال", "قصص أطفال",
      "غرفة نوم أطفال", "خزانة ملابس أطفال", "مكتب دراسة أطفال", "رفوف أطفال",
      "ميزان حرارة أطفال", "جهاز مراقبة أطفال (بيبي مونيتور)", "أدوية ومكملات أطفال",
      "معقمات رضاعات", "مستلزمات التسنين",
      "هدايا أطفال", "ديكور غرف أطفال", "أخرى"
    ]
  },
  "tibbi": {
    name: "المستلزمات الطبية",
    nameAr: "المستلزمات الطبية",
    nameEn: "Medical Supplies",
    nameTr: "Tıbbi Malzemeler",
    nameZh: "医疗用品",
    subcategories: [
      // الأجهزة الطبية
      "أجهزة قياس ضغط الدم", "أجهزة قياس السكر", "أجهزة قياس الأكسجين", "أجهزة تخطيط القلب", "أجهزة الموجات فوق الصوتية", "أجهزة التعقيم",
      // مستلزمات المستشفيات والعيادات
      "أسرة مستشفيات", "نقالات مرضى", "عربات طبية", "ستائر طبية", "حاويات نفايات طبية", "أغطية يد واحدة",
      // المواد الاستهلاكية
      "شاش وضمادات", "قطن طبي", "أشرطة لاصقة طبية", "قفازات طبية", "كمامات", "حقن (بدون أدوية)",
      // معدات المختبرات
      "أجهزة تحليل مخبرية", "مجاهر", "أنابيب اختبار", "حاويات عينات", "مستلزمات سحب الدم",
      // التأهيل والحركة
      "كراسي متحركة", "مشايات وعكازات", "أطراف صناعية", "جبائر ودعامات", "أجهزة علاج طبيعي",
      // الرعاية المنزلية
      "أسرة رعاية منزلية", "فرشات طبية", "مكثفات أكسجين", "أجهزة شفط", "أجهزة مراقبة المريض",
      // مستلزمات التمريض
      "قسطرات", "أنابيب تغذية", "أكياس بول", "أجهزة قياس العلامات الحيوية", "ملحقات المحاليل",
      // مستلزمات طب الأسنان
      "كراسي أسنان", "أدوات طب الأسنان", "أجهزة تعقيم الأسنان", "أدوات تقويم الأسنان",
      // طب العيون والبصريات
      "نظارات طبية", "عدسات لاصقة", "أجهزة فحص النظر", "أدوات طب العيون",
      // الأدوات الجراحية
      "أدوات جراحية", "خيوط جراحية", "أجهزة كي كهربائي", "معدات غرف العمليات",
      // مكافحة العدوى والسلامة
      "معدات الحماية الشخصية (PPE)", "ملحقات التعقيم", "ملابس واقية", "أدوات سلامة النفايات الطبية"
    ]
  },
  "is-makineleri": {
    name: "المعدات الثقيلة",
    nameAr: "المعدات الثقيلة والصناعية",
    nameEn: "Industrial & Heavy Equipment",
    nameTr: "Endüstriyel ve Ağır Ekipman",
    nameZh: "工业和重型设备",
    subcategories: [
      // معدات البناء
      "حفارة", "حفارة صغيرة", "حفارة جنزير", "حفارة عجلات",
      "لودر", "بلدوزر", "جريدر", "رصاصة", "راصف أسفلت",
      "مضخة خرسانة", "خلاطة خرسانة", "محطة خرسانة", "رافعة برجية", "رافعة متنقلة",
      // التحميل والنقل
      "فورك ليفت", "فورك ليفت كهربائي", "فورك ليفت ديزل", "ترانسبالت",
      "رافعة بضائع", "منصة رفع",
      // مولدات وطاقة
      "مولد كهربائي", "مولد ديزل", "مولد بنزين", "مولد محمول",
      "ضاغط هواء", "كمبروسر",
      // معدات زراعية
      "جرار", "حصادة", "آلة حصاد العشب", "آلة بالات",
      "محراث", "مبذرة", "أنظمة الري", "مضخات زراعية",
      // معدات صناعية
      "ماكينة CNC", "مخرطة CNC", "فريزة CNC", "مخرطة", "فريزة",
      "ماكينة لحام", "لحام أرجون", "لحام MIG/MAG",
      "قص بلازما", "قص ليزر", "قص مياه", "منشار",
      "مكبس", "مكبس هيدروليكي", "ماكينة ثني", "ماكينة ثقب",
      // التعبئة والطباعة
      "ماكينة تعبئة", "ماكينة تغليف", "ماكينة طباعة", "طباعة رقمية"
    ]
  },
  "hizmetler": {
    name: "الخدمات",
    nameAr: "الخدمات",
    nameEn: "Services",
    nameTr: "Hizmetler",
    nameZh: "服务",
    subcategories: [
      // خدمات المنزل
      "ترميم وتجديد", "دهان", "سباكة", "كهرباء",
      "تكييف وتبريد", "أعمال حدادة", "نجارة", "ألمنيوم",
      "تركيب مطابخ", "تركيب أثاث", "فك وتركيب",
      // التنظيف
      "تنظيف منازل", "تنظيف سجاد", "تنظيف كنب", "تنظيف خزانات",
      "مكافحة حشرات", "تعقيم",
      // النقل
      "نقل أثاث", "نقل عفش", "شحن بضائع", "توصيل طلبات",
      // خدمات السيارات
      "صيانة سيارات", "ميكانيكي", "كهربائي سيارات", "سمكرة ودهان",
      "غسيل سيارات", "تلميع سيارات", "تغيير زيت",
      // خدمات رقمية
      "تصميم مواقع", "تطوير تطبيقات", "تصميم جرافيك", "طباعة", "تسويق رقمي",
      "إدارة سوشيال ميديا", "كتابة محتوى", "ترجمة",
      // التصميم والإبداع › تصميم الأزياء
      "تصميم أزياء نسائية", "تصميم أزياء رجالية", "تصميم أزياء أطفال",
      "تصميم أزياء مشتركة", "تصميم أزياء متنوعة",
      // الطباعة والتخصيص
      "طباعة شعارات على الملابس", "طباعة على الأقمشة والمنسوجات",
      // تصوير
      "تصوير فوتوغرافي", "تصوير فيديو", "تصوير منتجات", "تصوير مناسبات",
      "مونتاج فيديو",
      // مناسبات
      "تنظيم حفلات", "تنظيم أعراس", "ضيافة", "تأجير معدات",
      "دي جي", "فرقة موسيقية",
      // صحة وجمال
      "حلاق رجالي", "صالون نسائي", "مساج", "سبا",
      // قانونية ومالية
      "محاماة", "استشارات قانونية", "محاسبة", "استشارات مالية",
      // أخرى
      "صيانة أجهزة", "صيانة هواتف", "صيانة كمبيوتر"
    ]
  },
  "ozel-ders": {
    name: "الدروس الخصوصية",
    nameAr: "الدروس الخصوصية",
    nameEn: "Private Lessons",
    nameTr: "Özel Dersler",
    nameZh: "私人课程",
    subcategories: [
      // المواد الدراسية
      "رياضيات", "فيزياء", "كيمياء", "أحياء",
      "لغة عربية", "لغة إنجليزية", "لغة فرنسية", "لغة تركية",
      "تاريخ", "جغرافيا", "علوم", "اجتماعيات",
      // اللغات
      "تعليم لغات", "محادثة إنجليزية", "IELTS", "TOEFL",
      "لغة ألمانية", "لغة إسبانية", "لغة صينية", "لغة يابانية",
      // الموسيقى
      "دروس موسيقى", "بيانو", "جيتار", "كمان", "عود",
      "درامز", "ناي", "غناء",
      // الرياضة
      "سباحة", "تنس", "كرة قدم", "كرة سلة",
      "فنون قتالية", "كاراتيه", "تايكوندو", "جودو",
      "يوغا", "لياقة بدنية",
      // الفنون
      "رسم وتلوين", "خط عربي", "تصوير فوتوغرافي",
      "تصميم جرافيك", "تصميم أزياء",
      // التقنية
      "برمجة", "تطوير مواقع", "تصميم مواقع",
      "أوفيس", "فوتوشوب", "إليستريتور",
      // تحضير امتحانات
      "قدرات", "تحصيلي", "امتحانات دولية"
    ]
  },
  "is-ilanlari": {
    name: "الوظائف",
    nameAr: "الوظائف",
    nameEn: "Jobs",
    nameTr: "İşler",
    nameZh: "工作",
    subcategories: [
      // تقنية المعلومات
      "مبرمج", "مطور ويب", "مطور تطبيقات", "مهندس IT",
      "مصمم جرافيك", "مصمم UI/UX", "محلل بيانات", "أمن معلومات",
      // المبيعات والتسويق
      "مندوب مبيعات", "مسؤول تسويق", "تسويق رقمي", "إدارة سوشيال ميديا",
      "خدمة عملاء", "مسؤول علاقات عامة",
      // الإدارة
      "مدير", "مدير مشاريع", "مساعد إداري", "سكرتارية",
      "موارد بشرية", "محاسب", "مدير مالي",
      // الصحة
      "طبيب", "ممرض", "صيدلي", "أخصائي علاج طبيعي",
      "طبيب أسنان", "مساعد طبي",
      // الهندسة
      "مهندس مدني", "مهندس معماري", "مهندس كهرباء", "مهندس ميكانيكا",
      "مهندس صناعي", "مشرف موقع",
      // التعليم
      "معلم", "مدرس لغة إنجليزية", "مدرس رياضيات", "مدرب",
      // الضيافة والسياحة
      "شيف", "طباخ", "نادل", "موظف فندق",
      "مرشد سياحي", "موظف حجوزات",
      // أخرى
      "سائق", "عامل مستودع", "أمن وحراسة", "فني صيانة",
      "كاشير", "موظف استقبال", "عمل حر"
    ]
  },
  "yardimci-arayanlar": {
    name: "مطلوب مساعدين",
    nameAr: "مطلوب مساعدين",
    nameEn: "Help Wanted",
    nameTr: "Yardım Aranıyor",
    nameZh: "寻求帮助",
    subcategories: [
      // رعاية
      "مربية أطفال", "جليسة أطفال", "مربية منزلية",
      "رعاية مسنين", "ممرض منزلي", "مرافق",
      // خدمة منزلية
      "عاملة منزلية", "طباخة", "سائق خاص",
      "بستاني", "حارس منزل", "عامل نظافة",
      // مكتب ومتجر
      "موظف متجر", "كاشير", "موظف استقبال",
      "مساعد مكتب", "ساعي"
    ]
  },
  "hayvanlar-alemi": {
    name: "الحيوانات",
    nameAr: "عالم الحيوانات",
    nameEn: "Pets & Animals",
    nameTr: "Evcil Hayvanlar ve Hayvanlar",
    nameZh: "宠物和动物",
    subcategories: ANIMAL_CATEGORY_GROUPS.flatMap((group) => [...group.subcategories])
  }
} as const;

export type CategoryKey = keyof typeof CATEGORIES;

// Image-upload limit per listing category. Cars and real-estate
// commonly need many photos (interior + exterior + odometer + papers
// for vasita; every room + facade + plan for emlak), so they get a
// 20-photo allowance. Every other category keeps the historical
// 5-photo cap because the cost / processing burden isn't justified.
// Single source so the create-listing form on web and the same form
// reused in the create-listing dialog (both shipped inside the
// Capacitor binary) stay in lock-step with no chance of drifting
// apart between native and web shells.
export const DEFAULT_LISTING_IMAGE_LIMIT = 5;
export const EXTENDED_LISTING_IMAGE_LIMIT = 20;
const EXTENDED_IMAGE_CATEGORIES = new Set<string>(["vasita", "emlak"]);
export function getListingImageLimit(category: string | null | undefined): number {
  if (category && EXTENDED_IMAGE_CATEGORIES.has(category)) {
    return EXTENDED_LISTING_IMAGE_LIMIT;
  }
  return DEFAULT_LISTING_IMAGE_LIMIT;
}

// Iraqi cities and districts - مرتبة أبجدياً
export const IRAQ_CITIES = {
  "أربيل": ["إيسكان", "التجارية", "بنازي", "روناكي", "شوقي", "شورش", "عينكاوا", "كاني"],
  "البصرة": ["أبو الخصيب", "الجبيلة", "الجزائر", "الزبير", "العشار", "الفاو", "القرنة", "المعقل", "البصرة القديمة", "شط العرب"],
  "الحلة": ["الإصلاح", "العسكري", "الموحدين", "النسيج", "بابل"],
  "الديوانية": ["الداغرة", "الشامية", "المركز", "عفك"],
  "الرمادي": ["الفلوجة", "المركز", "حديثة", "هيت"],
  "السليمانية": ["باخ", "رابرين", "زرين شار", "سالم", "كوران"],
  "العمارة": ["الإصلاح", "الصناعية", "المركز", "المعلمين"],
  "الكوت": ["الحي", "الزهراء", "العزيزية", "المركز"],
  "الموصل": ["17 تموز", "الدواسة", "الزهور", "السكر", "الكرامة", "المجموعة الثقافية", "الوحدة", "حي الضباط"],
  "الناصرية": ["الإصلاح", "البطحاء", "الحبوبي", "الشيخلية", "الفيصلية"],
  "النجف": ["الأشرف", "الأمير", "الجديدة", "الحنانة", "السعد", "الفرات", "المركز"],
  "بعقوبة": ["المركز", "المقدادية", "خانقين"],
  "بغداد": [
    // جانب الرصافة
    "مركز الرصافة", "الشورجة", "شارع المتنبي", "شارع الرشيد", "الباب الشرقي", "السعدون", "أبو نؤاس", "باب المعظم",
    "الكرادة", "الكرادة داخل", "الكرادة خارج", "العرصات", "الجادرية", "حي بابل", "حي الوحدة",
    "الأعظمية", "حي المغرب", "حي القاهرة", "حي تونس", "الصليخ", "سبع أبكار", "حي الربيع", "الوزيرية",
    "مدينة الصدر", "الحبيبية", "حي الأمانة", "حي الطارق", "حي النصر",
    "شارع فلسطين", "حي المستنصرية", "حي المهندسين", "حي الإدريسي", "حي النيل",
    "الشعب", "حي البنوك", "حي سومر", "حي أور", "الثعالبة",
    "بغداد الجديدة والغدير", "الغدير", "زيونة", "المشتل", "النعيرية",
    "المجمعات السكنية (الرصافة)", "مدينة بسماية السكنية", "مجمع الزهور", "مجمع جوهرة بغداد", "مجمع الأيادي",
    "أطراف الرصافة", "الزعفرانية", "جسر ديالى", "حي الرشاد",
    // جانب الكرخ
    "مركز الكرخ", "الصالحية", "الشواكة", "الكريمات", "علاوي الحلة", "الشيخ معروف",
    "المنصور", "حي دراغ", "الداودي", "اليرموك", "حي الجامعة", "الخضراء", "القادسية", "الحارثية",
    "الكاظمية", "حي الأنباريين", "العطيفية", "الهويدر", "الحرية", "الشعلة",
    "الدورة", "حي الميكانيك", "حي الآثاريين", "حي آسيا", "حي المعلمين", "هور رجب",
    "السيدية والرشيد", "السيدية", "حي الإعلام", "حي المواصلات", "حي التراث", "السويب",
    "البياع وحي العامل", "البياع", "حي العامل", "حي الجهاد", "حي الفرات", "حي السلام",
    "المجمعات السكنية (الكرخ)", "مجمع بوابة بغداد السكني", "مجمع اليمامة", "مجمع النصر السكني", "مجمع مدينة السلام",
    "أقضية وغرب الكرخ", "الغزالية", "العامرية", "أبو غريب", "التاجي", "المحمودية"
  ],
  "صلاح الدين": ["تكريت", "سامراء", "الشرقاط", "بيجي", "بلد", "الدور", "الطوز"],
  "دهوك": ["زاخو", "شيخان", "العمادية", "سميل"],
  "كربلاء": ["الأكرمين", "الحسينية", "العباسية", "المركز", "المعلمين", "الورود"],
  "كركوك": ["الحرية", "الواسطي", "العروبة", "رحيماوا", "شورجة"],
  "أخرى": ["أخرى"],
} as const;

const allCityKeys = Object.keys(IRAQ_CITIES) as (keyof typeof IRAQ_CITIES)[];
export const IRAQ_CITY_KEYS = [
  "بغداد" as keyof typeof IRAQ_CITIES,
  ...allCityKeys.filter(city => city !== "بغداد" && city !== "أخرى").sort((a, b) => a.localeCompare(b, 'ar')),
  "أخرى" as keyof typeof IRAQ_CITIES,
];

// Baghdad main district categories (shown in bold in dropdown)
export const BAGHDAD_MAIN_DISTRICTS = [
  // جانب الرصافة
  "مركز الرصافة",
  "الكرادة",
  "الأعظمية",
  "مدينة الصدر",
  "شارع فلسطين",
  "الشعب",
  "بغداد الجديدة والغدير",
  "المجمعات السكنية (الرصافة)",
  "أطراف الرصافة",
  // جانب الكرخ
  "مركز الكرخ",
  "المنصور",
  "الكاظمية",
  "الدورة",
  "السيدية والرشيد",
  "البياع وحي العامل",
  "المجمعات السكنية (الكرخ)",
  "أقضية وغرب الكرخ"
] as const;

// Currency options
export const CURRENCIES = ["IQD"] as const;
export type CurrencyType = typeof CURRENCIES[number];

// Universal color options used across listing forms
export const UNIVERSAL_COLOR_OPTIONS = [
  "أبيض",
  "أسود",
  "رمادي",
  "فحمي",
  "فضي",
  "ذهبي",
  "برونزي",
  "شامبين",
  "بيج",
  "عاجي",
  "كريمي",
  "بني",
  "بني فاتح",
  "كاكي",
  "أحمر",
  "عنابي",
  "برتقالي",
  "خوخي",
  "مرجاني",
  "أصفر",
  "خردلي",
  "أخضر",
  "أخضر زيتي",
  "أخضر نعناعي",
  "فيروزي",
  "تركواز",
  "أزرق",
  "أزرق سماوي",
  "أزرق غامق",
  "كحلي",
  "نيلي",
  "بنفسجي",
  "لافندر",
  "ليلكي",
  "وردي",
  "فوشي",
  "شفاف",
  "لؤلؤي",
  "ستانلس ستيل",
  "خشبي",
  "خشبي طبيعي",
  "متعدد الألوان",
  "أخرى",
] as const;

// Used by UI to render color swatches next to names
export const COLOR_SWATCH_HEX_BY_LABEL: Record<string, string> = {
  "أبيض": "#FFFFFF",
  "أسود": "#111111",
  "رمادي": "#9CA3AF",
  "فحمي": "#36454F",
  "فضي": "#C0C0C0",
  "ذهبي": "#D4AF37",
  "برونزي": "#CD7F32",
  "شامبين": "#F7E7CE",
  "بيج": "#F5F5DC",
  "عاجي": "#FFFFF0",
  "كريمي": "#FFFDD0",
  "بني": "#8B4513",
  "بني فاتح": "#C68642",
  "كاكي": "#C3B091",
  "أحمر": "#DC2626",
  "عنابي": "#800020",
  "برتقالي": "#F97316",
  "خوخي": "#FFCBA4",
  "مرجاني": "#FF7F50",
  "أصفر": "#FACC15",
  "خردلي": "#CDA434",
  "أخضر": "#16A34A",
  "أخضر زيتي": "#556B2F",
  "أخضر نعناعي": "#98FF98",
  "فيروزي": "#40E0D0",
  "تركواز": "#30D5C8",
  "أزرق": "#2563EB",
  "أزرق سماوي": "#38BDF8",
  "أزرق غامق": "#1E3A8A",
  "كحلي": "#1F3B73",
  "نيلي": "#4B0082",
  "بنفسجي": "#7C3AED",
  "لافندر": "#E6E6FA",
  "ليلكي": "#C8A2C8",
  "وردي": "#EC4899",
  "فوشي": "#C026D3",
  "شفاف": "linear-gradient(135deg, #ffffff 25%, #e5e7eb 25%, #e5e7eb 50%, #ffffff 50%, #ffffff 75%, #e5e7eb 75%, #e5e7eb)",
  "لؤلؤي": "linear-gradient(135deg, #fffdf8 0%, #f3f4f6 45%, #fef3c7 100%)",
  "ستانلس ستيل": "linear-gradient(135deg, #d1d5db 0%, #9ca3af 50%, #e5e7eb 100%)",
  "خشبي": "linear-gradient(135deg, #8B5A2B 0%, #A47148 100%)",
  "خشبي طبيعي": "linear-gradient(135deg, #C08A52 0%, #E3B778 100%)",
  "أبيض بارد": "#F8FAFC",
  "أبيض دافئ": "#FFF3E0",
  "متعدد الألوان": "conic-gradient(from 90deg, #ef4444, #f59e0b, #22c55e, #3b82f6, #a855f7, #ef4444)",
  "أخرى": "#D1D5DB",
};

export function getUniversalColorOptions(existingOptions?: readonly string[]): string[] {
  const merged = new Set<string>(UNIVERSAL_COLOR_OPTIONS);
  for (const option of existingOptions || []) {
    if (option && option !== "أخرى") merged.add(option);
  }
  const withoutOther = Array.from(merged).filter((o) => o !== "أخرى");
  return [...withoutOther, "أخرى"];
}

// Category-specific attribute definitions
export const CATEGORY_ATTRIBUTES = {
  "emlak": {
    fields: [
      // Basic Info
      { key: "listingType", label: "نوع الإعلان", type: "select", options: ["للبيع", "للإيجار", "للإيجار اليومي", "أخرى"], required: true },
      { key: "propertyType", label: "نوع العقار", type: "select", options: ["شقة", "فيلا", "منزل مستقل", "بيت طابقين", "بيت ريفي", "مزرعة", "محل تجاري", "مكتب", "مستودع", "أرض", "أرض سكنية", "أرض تجارية", "أرض زراعية", "مصنع", "فندق", "مطعم", "أخرى"], required: true },
      
      // Room Details
      { key: "rooms", label: "عدد الغرف", type: "select", options: ["استوديو", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"], required: true },
      { key: "livingRooms", label: "عدد غرف المعيشة", type: "select", options: ["0", "1", "2", "3+", "أخرى"], required: true },
      { key: "bathrooms", label: "عدد الحمامات", type: "select", options: ["1", "2", "3", "4", "5", "6+", "أخرى"], required: true },
      
      // Size
      { key: "grossArea", label: "المساحة الإجمالية (م²)", type: "number", required: true, min: 1, max: 999999 },
      { key: "netArea", label: "مساحة البناء (م²)", type: "number", min: 1, max: 999999 },
      
      // Building Info
      { key: "floor", label: "رقم الطابق", type: "select", options: ["سرداب", "طابق الحديقة", "الأرضي", "طابق مرتفع", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11-15", "16-20", "21-30", "31+", "أخرى"] },
      { key: "totalFloors", label: "عدد طوابق المبنى", type: "select", options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11-15", "16-20", "21-30", "31+", "أخرى"] },
      { key: "buildingAge", label: "عمر البناء", type: "select", options: ["0 (جديد)", "1-5 سنوات", "6-10 سنوات", "11-15 سنة", "16-20 سنة", "21-25 سنة", "26-30 سنة", "أكثر من 30 سنة", "أخرى"], required: true },
      { key: "unitsPerFloor", label: "عدد الشقق في الطابق", type: "select", options: ["1", "2", "3", "4", "5+", "أخرى"] },
      
      // Features
      { key: "furnishing", label: "التأثيث", type: "select", options: ["مفروش بالكامل", "نصف مفروش", "غير مفروش", "أخرى"], required: true },
      { key: "heating", label: "نظام التدفئة", type: "select", options: ["غاز طبيعي (كومبي)", "تدفئة مركزية", "مكيف سبليت", "تدفئة أرضية", "مدفأة", "بدون تدفئة", "أخرى"] },
      { key: "cooling", label: "نظام التبريد", type: "select", options: ["مكيف مركزي", "مكيف سبليت", "مكيف شباك", "بدون تبريد", "أخرى"] },
      { key: "waterHeating", label: "سخان المياه", type: "select", options: ["كهربائي", "غاز", "طاقة شمسية", "مركزي", "أخرى"] },
      
      // Additional Features (checkboxes - using multiselect)
      { key: "features", label: "المميزات الإضافية", type: "multiselect", options: [
        "مصعد", "موقف سيارات", "موقف سيارات مغطى", "حديقة خاصة", "تراس", "بلكونة", "مسبح", "مسبح مشترك", 
        "صالة رياضية", "ساونا", "حمام تركي", "أمن وحراسة 24 ساعة", "كاميرات مراقبة", "إنتركم مرئي",
        "مولد كهربائي", "خزان مياه", "غرفة خادمة", "غرفة غسيل", "مخزن", "غرفة ملابس (دريسنج)",
        "مطبخ مفتوح", "مطبخ مغلق", "جاكوزي", "شرفة زجاجية", "تدفئة أرضية", "عازل حراري",
        "عازل صوتي", "باب حديد", "ستائر", "مكيفات", "أثاث مطبخ", "غاز مركزي", "إنترنت ألياف", "أخرى"
      ]},
      
      // Legal & Documents
      { key: "titleDeed", label: "سند الملكية (الطابو)", type: "select", options: ["طابو ملك صرف سكني", "طابو ملك صرف زراعي", "طابو ملك صرف صناعي", "طابو ملك صرف تجاري", "سند زراعي رقم 25", "سند زراعي رقم 17", "أخرى"], required: true },
      { key: "eligible", label: "مناسب لـ", type: "select", options: ["الجميع", "عائلات فقط", "عزاب", "طلاب", "شركات", "أخرى"] },
      
      // Rent-specific
      { key: "deposit", label: "مبلغ التأمين", type: "number" },
      { key: "minRentPeriod", label: "الحد الأدنى للإيجار", type: "select", options: ["يوم واحد", "أسبوع", "شهر", "3 أشهر", "6 أشهر", "سنة", "أخرى"] },
      
      // Sale-specific
      { key: "priceNegotiable", label: "السعر قابل للتفاوض", type: "select", options: ["نعم", "لا"] },
      { key: "exchangePossible", label: "قابل للمبادلة", type: "select", options: ["نعم", "لا"] },
    ]
  },
  "vasita": {
    fields: [
      { key: "brand", label: "الماركة", type: "vehicle_brand", required: true },
      { key: "series", label: "الفئة", type: "vehicle_series", dependsOn: "brand", required: true },
      { key: "model", label: "الموديل", type: "vehicle_model", dependsOn: "series", required: true },
      { key: "year", label: "سنة الصنع", type: "vehicle_year", required: true },
      { key: "fuelType", label: "نوع الوقود", type: "vehicle_fuel", required: true },
      { key: "transmission", label: "ناقل الحركة", type: "vehicle_transmission", required: true },
      { key: "mileage", label: "المسافة المقطوعة (كم)", type: "vehicle_mileage", required: true },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "فضي", "رمادي", "أحمر", "أزرق", "أخضر", "بني", "ذهبي", "برتقالي", "أصفر", "بيج", "لؤلؤي", "شامبين", "برونزي", "بنفسجي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد (0 كم)", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "يحتاج صيانة", "متضررة", "أخرى"], required: true },
      // bodyType field intentionally removed — the listing's `subcategory`
      // already captures the body type (سيدان / دفع رباعي / بيك أب / …)
      // and is the same value the browse tree uses at level 1. Asking
      // for both would force the seller to pick body type twice and
      // split the data between two columns. Subcategory is the single
      // source of truth for body type.
      { key: "engineSize", label: "حجم المحرك", type: "vehicle_engine_size", required: true },
      { key: "driveType", label: "نوع الدفع", type: "select", options: ["دفع أمامي (FWD)", "دفع خلفي (RWD)", "دفع رباعي (4WD)", "دفع كلي (AWD)", "أخرى"] },
      { key: "origin", label: "المنشأ", type: "select", options: ["خليجي", "أمريكي", "ألماني", "أوروبي", "كوري", "ياباني", "صيني", "عراقي", "أخرى"] },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان وكالة", "يوجد ضمان طرف ثالث", "لا يوجد ضمان"] },
      { key: "serviceHistory", label: "سجل الصيانة", type: "select", options: ["صيانة وكالة كاملة", "صيانة وكالة جزئية", "صيانة خارجية", "غير متوفر"] },
      { key: "accidents", label: "حوادث سابقة", type: "select", options: ["بدون حوادث", "حادث بسيط", "حادث متوسط", "حادث شديد", "غير معروف"] },
      { key: "doors", label: "عدد الأبواب", type: "select", options: ["2", "3", "4", "5", "أخرى"] },
      { key: "seats", label: "عدد المقاعد", type: "select", options: ["2", "4", "5", "6", "7", "8", "9+", "أخرى"] },
      { key: "bodyConditionReport", label: "تقرير حالة الهيكل", type: "body_condition_report" },
    ]
  },
  "alisveris": {
    fields: [
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "للقطع", "أخرى"] },
      { key: "availableSizes", label: "المقاسات المتوفرة", type: "multiselect", options: ["XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "مقاس موحد", "أخرى"] },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "riyada": {
    fields: [
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"] },
      { key: "brand", label: "الماركة", type: "select", options: [] },
      { key: "availableSizes", label: "المقاسات المتوفرة", type: "multiselect", options: ["XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL", "36", "37", "37.5", "38", "38.5", "39", "39.5", "40", "40.5", "41", "41.5", "42", "42.5", "43", "43.5", "44", "44.5", "45", "45.5", "46", "46.5", "47", "47.5", "48", "48.5", "49", "49.5", "50", "50.5", "51", "51.5", "52", "مقاس موحد", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "رمادي", "أحمر", "أزرق", "أزرق غامق", "أخضر", "أصفر", "برتقالي", "وردي", "بنفسجي", "بني", "بيج", "ذهبي", "فضي", "متعدد الألوان", "أخرى"] },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "atfal": {
    fields: [
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"] },
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["حديث الولادة (0-3 أشهر)", "رضيع (3-12 شهر)", "1-2 سنة", "3-5 سنوات", "6-8 سنوات", "9-12 سنة", "13+ سنة", "جميع الأعمار"] },
      { key: "gender", label: "الجنس", type: "select", options: ["ولد", "بنت", "للجنسين"] },
      { key: "brand", label: "الماركة", type: "select", options: ["Chicco", "Graco", "Mothercare", "Carter's", "H&M Kids", "Zara Kids", "LC Waikiki", "Nike Kids", "Adidas Kids", "Pampers", "Huggies", "Aptamil", "Similac", "Fisher-Price", "LEGO", "Disney", "أخرى"] },
      { key: "availableSizes", label: "المقاسات المتوفرة", type: "multiselect", options: ["حديث الولادة", "0-3 شهور", "3-6 شهور", "6-9 شهور", "9-12 شهر", "12-18 شهر", "18-24 شهر", "2-3 سنة", "3-4 سنة", "4-5 سنة", "5-6 سنة", "6-7 سنة", "7-8 سنة", "8-9 سنة", "9-10 سنة", "10-11 سنة", "11-12 سنة", "12-13 سنة", "13-14 سنة", "مقاس موحد", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "رمادي", "أحمر", "أزرق", "أزرق غامق", "أخضر", "أصفر", "برتقالي", "وردي", "بنفسجي", "بني", "بيج", "متعدد الألوان", "أخرى"] },
    ]
  },
  "tibbi": {
    fields: [
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "معاد تعقيم", "أخرى"] },
      { key: "brand", label: "الشركة المصنعة", type: "text" },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
      { key: "certification", label: "الشهادات", type: "select", options: ["FDA", "CE", "ISO", "وزارة الصحة", "بدون", "أخرى"] },
    ]
  },
  "yedek-parca": {
    fields: [
      { key: "partCondition", label: "حالة القطعة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "معاد تصنيع", "أخرى"] },
      { key: "compatibility", label: "التوافق", type: "text" },
    ]
  },
  "is-makineleri": {
    fields: [
      { key: "machineType", label: "نوع الآلة", type: "text" },
      { key: "brand", label: "الماركة", type: "text" },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 30}, (_, i) => String(2025 - i)) },
      { key: "workingHours", label: "ساعات العمل", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"] },
    ]
  },
  "hizmetler": {
    fields: [
      { key: "serviceType", label: "نوع الخدمة", type: "select", options: ["منزلي", "في الموقع", "أونلاين", "الكل", "أخرى"] },
      { key: "availability", label: "التوفر", type: "select", options: ["متاح يومياً", "أيام العمل فقط", "عطلة نهاية الأسبوع", "بالموعد", "أخرى"] },
    ]
  },
  "ozel-ders": {
    fields: [
      { key: "teachingMethod", label: "طريقة التدريس", type: "select", options: ["حضوري", "أونلاين", "كلاهما", "أخرى"] },
      { key: "experience", label: "الخبرة", type: "select", options: ["أقل من سنة", "1-3 سنوات", "3-5 سنوات", "5-10 سنوات", "أكثر من 10 سنوات", "أخرى"] },
      { key: "targetLevel", label: "المستوى المستهدف", type: "select", options: ["ابتدائي", "متوسط", "ثانوي", "جامعي", "الكل", "أخرى"] },
    ]
  },
  "is-ilanlari": {
    fields: [
      { key: "employmentType", label: "نوع العمل", type: "select", options: ["دوام كامل", "دوام جزئي", "عن بعد", "عقد مؤقت", "تدريب", "أخرى"] },
      { key: "experience", label: "الخبرة المطلوبة", type: "select", options: ["لا يشترط", "1-2 سنة", "3-5 سنوات", "5-10 سنوات", "أكثر من 10 سنوات", "أخرى"] },
      { key: "education", label: "المؤهل", type: "select", options: ["لا يشترط", "ثانوي", "دبلوم", "بكالوريوس", "ماجستير", "دكتوراه", "أخرى"] },
    ]
  },
  "yardimci-arayanlar": {
    fields: [
      { key: "workType", label: "نوع العمل", type: "select", options: ["دوام كامل", "دوام جزئي", "مؤقت", "أخرى"] },
      { key: "accommodation", label: "السكن", type: "select", options: ["يوفر سكن", "لا يوفر سكن", "أخرى"] },
    ]
  },
  "hayvanlar-alemi": {
    fields: [
      { key: "animalType", label: "نوع الحيوان", type: "text" },
      { key: "age", label: "العمر", type: "select", options: ["أقل من شهر", "1-6 شهور", "6-12 شهر", "1-2 سنة", "2-5 سنوات", "أكثر من 5 سنوات", "أخرى"] },
      { key: "gender", label: "الجنس", type: "select", options: ["ذكر", "أنثى", "أخرى"] },
      { key: "vaccinated", label: "التطعيم", type: "select", options: ["مطعم", "غير مطعم", "أخرى"] },
    ]
  }
} as const;

// Subcategory-specific fields that override category fields
export const sportsBrandsBySubcategory: Record<string, string[]> = {
  "أحذية رياضية": ["Nike", "Adidas", "Puma", "New Balance", "Reebok", "Under Armour", "ASICS", "Skechers", "Fila", "Converse", "Vans", "Jordan", "Columbia", "أخرى"],
  "أحذية كرة قدم": ["Nike", "Adidas", "Puma", "Under Armour", "New Balance", "Mizuno", "Joma", "Lotto", "Umbro", "Diadora", "أخرى"],
  "أحذية جري": ["Nike", "Adidas", "ASICS", "New Balance", "Brooks", "Hoka", "Saucony", "Under Armour", "Puma", "Reebok", "On Running", "Columbia", "أخرى"],
  "أحذية كرة سلة": ["Nike", "Jordan", "Adidas", "Under Armour", "Puma", "New Balance", "Reebok", "AND1", "Li-Ning", "Columbia", "أخرى"],
  "ملابس رياضية": ["Nike", "Adidas", "Puma", "Under Armour", "Reebok", "New Balance", "Fila", "Champion", "Gymshark", "أخرى"],
  "ملابس تدريب": ["Nike", "Adidas", "Under Armour", "Gymshark", "Puma", "Reebok", "Venum", "Lululemon", "أخرى"],
  "ملابس سباحة": ["Speedo", "Arena", "TYR", "Nike", "Adidas", "Puma", "أخرى"],
  "ملابس رياضية نسائية": ["Nike", "Adidas", "Under Armour", "Puma", "Gymshark", "Lululemon", "Reebok", "Fila", "أخرى"],
  "ملابس رياضية رجالية": ["Nike", "Adidas", "Under Armour", "Puma", "Gymshark", "Reebok", "New Balance", "Champion", "أخرى"],
  "ملابس رياضية أطفال": ["Nike", "Adidas", "Puma", "Under Armour", "Reebok", "New Balance", "أخرى"],
  "حقائب رياضية": ["Nike", "Adidas", "Puma", "Under Armour", "Reebok", "The North Face", "أخرى"],
  "حقائب ظهر رياضية": ["Nike", "Adidas", "Puma", "Under Armour", "The North Face", "Reebok", "أخرى"],
  "حقائب سفر رياضية": ["Nike", "Adidas", "Puma", "Under Armour", "The North Face", "Samsonite", "أخرى"],
  "إكسسوارات رياضية": ["Nike", "Adidas", "Under Armour", "Puma", "Reebok", "أخرى"],
  "ساعات رياضية": ["Garmin", "Apple", "Samsung", "Fitbit", "Suunto", "Polar", "Casio G-Shock", "Amazfit", "Huawei", "أخرى"],
  "نظارات رياضية": ["Oakley", "Nike", "Adidas", "Under Armour", "Ray-Ban", "Julbo", "أخرى"],
  "قفازات رياضية": ["Nike", "Adidas", "Under Armour", "Everlast", "Venum", "RDX", "Harbinger", "أخرى"],
  "أحزمة رياضية": ["Nike", "Adidas", "Under Armour", "Harbinger", "RDX", "Schiek", "أخرى"],
  "معدات كمال الأجسام": ["Rogue Fitness", "Life Fitness", "Technogym", "Hammer Strength", "Bowflex", "PowerBlock", "REP Fitness", "Eleiko", "أخرى"],
  "أوزان حديدية": ["Rogue Fitness", "Eleiko", "REP Fitness", "Bowflex", "PowerBlock", "York Barbell", "CAP Barbell", "أخرى"],
  "بار حديد": ["Rogue Fitness", "Eleiko", "REP Fitness", "York Barbell", "CAP Barbell", "Titan Fitness", "أخرى"],
  "كيتل بل": ["Rogue Fitness", "REP Fitness", "Kettlebell Kings", "CAP Barbell", "Titan Fitness", "أخرى"],
  "أغذية وبروتين": ["Optimum Nutrition", "MuscleTech", "BSN", "Dymatize", "MyProtein", "Universal Nutrition", "Cellucor", "MusclePharm", "ISO100", "Kevin Levrone", "Rule One", "Applied Nutrition", "BioTech USA", "أخرى"],
  "معدات كرة القدم": ["Nike", "Adidas", "Puma", "Mitre", "Select", "Molten", "Mikasa", "أخرى"],
  "كرة قدم": ["Nike", "Adidas", "Puma", "Mitre", "Select", "Molten", "أخرى"],
  "شبك مرمى": ["Kwik Goal", "FORZA", "Franklin Sports", "أخرى"],
  "معدات كرة السلة": ["Spalding", "Wilson", "Nike", "Molten", "Mikasa", "أخرى"],
  "معدات تنس": ["Wilson", "Head", "Babolat", "Yonex", "Prince", "Tecnifibre", "Dunlop", "أخرى"],
  "معدات سباحة": ["Speedo", "Arena", "TYR", "Nike", "Aqua Sphere", "FINIS", "أخرى"],
  "دراجات هوائية رياضية": ["Trek", "Giant", "Specialized", "Cannondale", "Scott", "Merida", "Bianchi", "أخرى"],
  "إكسسوارات دراجات": ["Shimano", "SRAM", "Garmin", "Cateye", "Knog", "أخرى"],
};

export const subcategorySpecificFields: Record<string, { fields: { key: string; label: string; type: string; options?: string[]; required?: boolean }[] }> = {
  "طائرات": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Boeing", "Airbus", "Cessna", "Piper", "Beechcraft", "Bombardier", "Embraer", "Gulfstream", "Dassault", "Pilatus", "Cirrus", "Diamond", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 50}, (_, i) => String(2025 - i)), required: true },
      { key: "aircraftType", label: "نوع الطائرة", type: "select", options: ["طائرة ركاب", "طائرة شحن", "طائرة خاصة", "طائرة تدريب", "طائرة رياضية", "طائرة زراعية", "أخرى"], required: true },
      { key: "engineType", label: "نوع المحرك", type: "select", options: ["محرك مكبسي", "توربيني", "نفاث", "كهربائي", "أخرى"], required: true },
      { key: "engineCount", label: "عدد المحركات", type: "select", options: ["1", "2", "3", "4", "أكثر"], required: true },
      { key: "flightHours", label: "ساعات الطيران", type: "number", required: true },
      { key: "seatingCapacity", label: "سعة المقاعد", type: "number" },
      { key: "range", label: "المدى (كم)", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
      { key: "registration", label: "التسجيل", type: "select", options: ["مسجلة", "غير مسجلة", "قيد التسجيل"] },
      { key: "certification", label: "الشهادات", type: "select", options: ["FAA", "EASA", "عراقية", "أخرى"] },
    ]
  },
  "هليكوبتر": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Bell", "Airbus Helicopters", "Sikorsky", "Leonardo", "MD Helicopters", "Robinson", "Eurocopter", "Boeing", "AgustaWestland", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 50}, (_, i) => String(2025 - i)), required: true },
      { key: "helicopterType", label: "نوع الهليكوبتر", type: "select", options: ["نقل ركاب", "شحن", "طبي", "بحث وإنقاذ", "سياحي", "تدريب", "زراعي", "أخرى"], required: true },
      { key: "engineType", label: "نوع المحرك", type: "select", options: ["توربيني", "مكبسي", "أخرى"], required: true },
      { key: "engineCount", label: "عدد المحركات", type: "select", options: ["1", "2", "أكثر"], required: true },
      { key: "flightHours", label: "ساعات الطيران", type: "number", required: true },
      { key: "seatingCapacity", label: "سعة المقاعد", type: "number" },
      { key: "maxSpeed", label: "السرعة القصوى (كم/س)", type: "number" },
      { key: "range", label: "المدى (كم)", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
      { key: "registration", label: "التسجيل", type: "select", options: ["مسجلة", "غير مسجلة", "قيد التسجيل"] },
    ]
  },
  "قوارب": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Yamaha", "Mercury", "Sea Ray", "Boston Whaler", "Bayliner", "Chaparral", "Grady-White", "Pursuit", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 40}, (_, i) => String(2025 - i)), required: true },
      { key: "boatType", label: "نوع القارب", type: "select", options: ["قارب صيد", "قارب نزهة", "قارب سباق", "قارب عمل", "أخرى"], required: true },
      { key: "length", label: "الطول (قدم)", type: "number", required: true },
      { key: "engineType", label: "نوع المحرك", type: "select", options: ["خارجي", "داخلي", "كهربائي", "شراعي", "أخرى"] },
      { key: "engineHours", label: "ساعات المحرك", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "يخت": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Azimut", "Sunseeker", "Princess", "Ferretti", "Benetti", "Riva", "Pershing", "Fairline", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 40}, (_, i) => String(2025 - i)), required: true },
      { key: "yachtType", label: "نوع اليخت", type: "select", options: ["موتور يخت", "شراعي", "كاتاماران", "ميجا يخت", "أخرى"], required: true },
      { key: "length", label: "الطول (قدم)", type: "number", required: true },
      { key: "cabins", label: "عدد الغرف", type: "select", options: ["1", "2", "3", "4", "5", "6+"] },
      { key: "engineHours", label: "ساعات المحرك", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "دراجة نارية": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Honda", "Yamaha", "Suzuki", "Kawasaki", "Ducati", "BMW", "Harley-Davidson", "KTM", "Triumph", "Aprilia", "Benelli", "Lifan", "Zongshen", "Loncin", "TVS", "Bajaj", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 30}, (_, i) => String(2025 - i)), required: true },
      { key: "engineSize", label: "سعة المحرك (CC)", type: "select", options: ["50", "100", "110", "125", "150", "200", "250", "300", "400", "600", "750", "1000", "1200+", "أخرى"], required: true },
      { key: "mileage", label: "المسافة المقطوعة (كم)", type: "number" },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "أحمر", "أزرق", "أخضر", "فضي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "سكوتر": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Honda", "Yamaha", "Suzuki", "Kawasaki", "Ducati", "BMW", "Harley-Davidson", "KTM", "Triumph", "Aprilia", "Benelli", "Lifan", "Zongshen", "Loncin", "TVS", "Bajaj", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 30}, (_, i) => String(2025 - i)), required: true },
      { key: "engineSize", label: "سعة المحرك (CC)", type: "select", options: ["50", "100", "110", "125", "150", "200", "250", "300", "400", "600", "750", "1000", "1200+", "أخرى"], required: true },
      { key: "mileage", label: "المسافة المقطوعة (كم)", type: "number" },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "أحمر", "أزرق", "أخضر", "فضي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "ATV": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Honda", "Yamaha", "Suzuki", "Kawasaki", "Ducati", "BMW", "Harley-Davidson", "KTM", "Triumph", "Aprilia", "Benelli", "Lifan", "Zongshen", "Loncin", "TVS", "Bajaj", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 30}, (_, i) => String(2025 - i)), required: true },
      { key: "engineSize", label: "سعة المحرك (CC)", type: "select", options: ["50", "100", "110", "125", "150", "200", "250", "300", "400", "600", "750", "1000", "1200+", "أخرى"], required: true },
      { key: "mileage", label: "المسافة المقطوعة (كم)", type: "number" },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "أحمر", "أزرق", "أخضر", "فضي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "دراجة كهربائية": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "text", required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 15}, (_, i) => String(2025 - i)), required: true },
      { key: "batteryRange", label: "مدى البطارية (كم)", type: "number" },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "أحمر", "أزرق", "أخضر", "فضي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "جت سكي": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "select", options: ["Yamaha", "Sea-Doo", "Kawasaki", "Honda", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 25}, (_, i) => String(2025 - i)), required: true },
      { key: "engineHours", label: "ساعات المحرك", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "شراعي": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "text", required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 40}, (_, i) => String(2025 - i)), required: true },
      { key: "length", label: "الطول (قدم)", type: "number", required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "مقطورة": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "text" },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 30}, (_, i) => String(2025 - i)) },
      { key: "trailerType", label: "نوع المقطورة", type: "select", options: ["مقطورة مسطحة", "مقطورة صندوق", "مقطورة مبردة", "مقطورة صهريج", "مقطورة نقل سيارات", "أخرى"], required: true },
      { key: "length", label: "الطول (متر)", type: "number" },
      { key: "loadCapacity", label: "الحمولة (طن)", type: "number" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },
  "كرفان": {
    fields: [
      { key: "brand", label: "الشركة المصنعة", type: "text", required: true },
      { key: "model", label: "الموديل", type: "text" },
      { key: "year", label: "سنة الصنع", type: "select", options: Array.from({length: 30}, (_, i) => String(2025 - i)), required: true },
      { key: "length", label: "الطول (متر)", type: "number" },
      { key: "beds", label: "عدد أماكن النوم", type: "select", options: ["1", "2", "3", "4", "5", "6+"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد", "يحتاج صيانة", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - COMPUTERS & TECH ====================
  "كمبيوتر": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["HP", "Dell", "Lenovo", "Asus", "Acer", "Apple", "MSI", "Samsung", "Toshiba", "أخرى"], required: true },
      { key: "processor", label: "المعالج", type: "select", options: ["Intel Core i3", "Intel Core i5", "Intel Core i7", "Intel Core i9", "AMD Ryzen 3", "AMD Ryzen 5", "AMD Ryzen 7", "AMD Ryzen 9", "Apple M1", "Apple M2", "Apple M3", "أخرى"], required: true },
      { key: "ram", label: "الرام (GB)", type: "select", options: ["4", "8", "16", "32", "64", "128", "أخرى"], required: true },
      { key: "storage", label: "التخزين", type: "select", options: ["128GB SSD", "256GB SSD", "512GB SSD", "1TB SSD", "2TB SSD", "500GB HDD", "1TB HDD", "2TB HDD", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["11", "12", "13", "14", "15", "15.6", "16", "17", "أخرى"] },
      { key: "gpu", label: "كرت الشاشة", type: "select", options: ["مدمج", "NVIDIA GTX 1650", "NVIDIA GTX 1660", "NVIDIA RTX 3050", "NVIDIA RTX 3060", "NVIDIA RTX 3070", "NVIDIA RTX 3080", "NVIDIA RTX 4060", "NVIDIA RTX 4070", "NVIDIA RTX 4080", "NVIDIA RTX 4090", "AMD RX 6600", "AMD RX 6700", "AMD RX 7600", "AMD RX 7800", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "لابتوب": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["HP", "Dell", "Lenovo", "Asus", "Acer", "Apple", "MSI", "Samsung", "Toshiba", "أخرى"], required: true },
      { key: "processor", label: "المعالج", type: "select", options: ["Intel Core i3", "Intel Core i5", "Intel Core i7", "Intel Core i9", "AMD Ryzen 3", "AMD Ryzen 5", "AMD Ryzen 7", "AMD Ryzen 9", "Apple M1", "Apple M2", "Apple M3", "أخرى"], required: true },
      { key: "ram", label: "الرام (GB)", type: "select", options: ["4", "8", "16", "32", "64", "128", "أخرى"], required: true },
      { key: "storage", label: "التخزين", type: "select", options: ["128GB SSD", "256GB SSD", "512GB SSD", "1TB SSD", "2TB SSD", "500GB HDD", "1TB HDD", "2TB HDD", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["11", "12", "13", "14", "15", "15.6", "16", "17", "أخرى"] },
      { key: "gpu", label: "كرت الشاشة", type: "select", options: ["مدمج", "NVIDIA GTX 1650", "NVIDIA GTX 1660", "NVIDIA RTX 3050", "NVIDIA RTX 3060", "NVIDIA RTX 3070", "NVIDIA RTX 3080", "NVIDIA RTX 4060", "NVIDIA RTX 4070", "NVIDIA RTX 4080", "NVIDIA RTX 4090", "AMD RX 6600", "AMD RX 6700", "AMD RX 7600", "AMD RX 7800", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كمبيوتر مكتبي": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["HP", "Dell", "Lenovo", "Asus", "Acer", "Apple", "MSI", "Samsung", "Toshiba", "أخرى"], required: true },
      { key: "processor", label: "المعالج", type: "select", options: ["Intel Core i3", "Intel Core i5", "Intel Core i7", "Intel Core i9", "AMD Ryzen 3", "AMD Ryzen 5", "AMD Ryzen 7", "AMD Ryzen 9", "Apple M1", "Apple M2", "Apple M3", "أخرى"], required: true },
      { key: "ram", label: "الرام (GB)", type: "select", options: ["4", "8", "16", "32", "64", "128", "أخرى"], required: true },
      { key: "storage", label: "التخزين", type: "select", options: ["128GB SSD", "256GB SSD", "512GB SSD", "1TB SSD", "2TB SSD", "500GB HDD", "1TB HDD", "2TB HDD", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["21", "24", "27", "32", "34", "أخرى"] },
      { key: "gpu", label: "كرت الشاشة", type: "select", options: ["مدمج", "NVIDIA GTX 1650", "NVIDIA GTX 1660", "NVIDIA RTX 3050", "NVIDIA RTX 3060", "NVIDIA RTX 3070", "NVIDIA RTX 3080", "NVIDIA RTX 4060", "NVIDIA RTX 4070", "NVIDIA RTX 4080", "NVIDIA RTX 4090", "AMD RX 6600", "AMD RX 6700", "AMD RX 7600", "AMD RX 7800", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كمبيوتر ألعاب": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["HP", "Dell", "Lenovo", "Asus", "Acer", "Apple", "MSI", "Samsung", "Toshiba", "أخرى"], required: true },
      { key: "processor", label: "المعالج", type: "select", options: ["Intel Core i3", "Intel Core i5", "Intel Core i7", "Intel Core i9", "AMD Ryzen 3", "AMD Ryzen 5", "AMD Ryzen 7", "AMD Ryzen 9", "Apple M1", "Apple M2", "Apple M3", "أخرى"], required: true },
      { key: "ram", label: "الرام (GB)", type: "select", options: ["4", "8", "16", "32", "64", "128", "أخرى"], required: true },
      { key: "storage", label: "التخزين", type: "select", options: ["128GB SSD", "256GB SSD", "512GB SSD", "1TB SSD", "2TB SSD", "500GB HDD", "1TB HDD", "2TB HDD", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["21", "24", "27", "32", "34", "أخرى"] },
      { key: "gpu", label: "كرت الشاشة", type: "select", options: ["مدمج", "NVIDIA GTX 1650", "NVIDIA GTX 1660", "NVIDIA RTX 3050", "NVIDIA RTX 3060", "NVIDIA RTX 3070", "NVIDIA RTX 3080", "NVIDIA RTX 4060", "NVIDIA RTX 4070", "NVIDIA RTX 4080", "NVIDIA RTX 4090", "AMD RX 6600", "AMD RX 6700", "AMD RX 7600", "AMD RX 7800", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "تابلت": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Apple", "Samsung", "Huawei", "Lenovo", "Microsoft", "Xiaomi", "Amazon", "أخرى"], required: true },
      { key: "storageCapacity", label: "سعة التخزين", type: "select", options: ["32GB", "64GB", "128GB", "256GB", "512GB", "1TB", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["7", "8", "10", "10.5", "11", "12.4", "12.9", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "آيباد": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Apple"], required: true },
      { key: "model", label: "الموديل", type: "select", options: ["iPad", "iPad Mini", "iPad Air", "iPad Pro 11\"", "iPad Pro 12.9\"", "أخرى"], required: true },
      { key: "storageCapacity", label: "سعة التخزين", type: "select", options: ["32GB", "64GB", "128GB", "256GB", "512GB", "1TB", "2TB", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["8.3", "10.2", "10.9", "11", "12.9", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "شاشة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Dell", "HP", "Asus", "Acer", "BenQ", "MSI", "ViewSonic", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["21", "24", "27", "32", "34", "40", "43", "49", "50", "55", "58", "60", "65", "70", "75", "77", "80", "82", "85", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["Full HD (1080p)", "2K (1440p)", "4K (2160p)", "أخرى"], required: true },
      { key: "panelType", label: "نوع اللوحة", type: "select", options: ["IPS", "VA", "TN", "OLED", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "طابعة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["HP", "Canon", "Epson", "Brother", "Samsung", "Xerox", "Ricoh", "أخرى"], required: true },
      { key: "printerType", label: "نوع الطابعة", type: "select", options: ["ليزر", "حبر", "حرارية", "3D", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "قطع الكمبيوتر": {
    fields: [
      { key: "partType", label: "نوع القطعة", type: "select", options: ["معالج", "كرت شاشة", "لوحة أم", "رام", "SSD", "هارد ديسك", "باور سبلاي", "كيس", "مروحة تبريد", "أخرى"], required: true },
      { key: "brand", label: "العلامة التجارية", type: "text", required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  // ==================== SHOPPING - PHONES ====================
  "هاتف محمول": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Apple", "Samsung", "Xiaomi", "Huawei", "Oppo", "Vivo", "OnePlus", "Google", "Nokia", "Motorola", "Realme", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "phone_model", required: true },
      { key: "storageCapacity", label: "سعة التخزين", type: "select", options: ["16GB", "32GB", "64GB", "128GB", "256GB", "512GB", "1TB", "أخرى"], required: true },
      { key: "ram", label: "الرام (GB)", type: "select", options: ["2", "3", "4", "6", "8", "12", "16", "32", "64", "128", "256", "أخرى"] },
      { key: "batteryCapacity", label: "سعة البطارية (mAh)", type: "text" },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["5.0", "5.5", "6.0", "6.1", "6.5", "6.7", "6.8", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخضر", "ذهبي", "فضي", "بنفسجي", "وردي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "إكسسوارات الهاتف": {
    fields: [
      { key: "compatibleBrand", label: "متوافق مع", type: "select", options: ["Apple", "Samsung", "Xiaomi", "Huawei", "Oppo", "عالمي", "أخرى"], required: true },
      { key: "accessoryType", label: "نوع الإكسسوار", type: "select", options: ["كفر", "شاحن", "سماعات", "واقي شاشة", "حامل", "بطارية خارجية", "كيبل", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "شفاف", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كفر": {
    fields: [
      { key: "compatibleBrand", label: "متوافق مع", type: "select", options: ["Apple", "Samsung", "Xiaomi", "Huawei", "Oppo", "عالمي", "أخرى"], required: true },
      { key: "compatibleModel", label: "الموديل المتوافق", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "شفاف", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "شاحن": {
    fields: [
      { key: "compatibleBrand", label: "متوافق مع", type: "select", options: ["Apple", "Samsung", "Xiaomi", "Huawei", "Oppo", "عالمي", "أخرى"], required: true },
      { key: "chargerType", label: "نوع الشاحن", type: "select", options: ["سلكي", "لاسلكي", "سيارة", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "سماعات": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Apple", "Samsung", "Sony", "JBL", "Bose", "Beats", "Anker", "Xiaomi", "أخرى"], required: true },
      { key: "headphoneType", label: "النوع", type: "select", options: ["سلكية", "لاسلكية", "بلوتوث", "داخل الأذن", "فوق الأذن", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "سماعة بلوتوث": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Apple", "Samsung", "Sony", "JBL", "Anker", "Xiaomi", "Huawei", "أخرى"], required: true },
      { key: "headphoneType", label: "الشكل", type: "select", options: ["إيربودز", "سماعة أذن واحدة", "هيدست", "بلوتوث رياضي", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },

  // ==================== SHOPPING - ELECTRONICS ====================
  "تلفزيون": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Sony", "TCL", "Hisense", "Toshiba", "Panasonic", "Philips", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["32", "40", "43", "50", "55", "58", "65", "70", "75", "85", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["HD", "Full HD", "4K", "8K", "أخرى"], required: true },
      { key: "smartFeatures", label: "المميزات الذكية", type: "select", options: ["سمارت", "غير سمارت", "Android TV", "WebOS", "Tizen", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "سمارت تي في": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Sony", "TCL", "Hisense", "Toshiba", "Panasonic", "Philips", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["32", "40", "43", "50", "55", "58", "65", "70", "75", "85", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["HD", "Full HD", "4K", "8K", "أخرى"], required: true },
      { key: "smartFeatures", label: "المميزات الذكية", type: "select", options: ["Android TV", "WebOS", "Tizen", "Google TV", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "LED TV": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Sony", "TCL", "Hisense", "Toshiba", "Panasonic", "Philips", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["32", "40", "43", "50", "55", "58", "65", "70", "75", "85", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["HD", "Full HD", "4K", "8K", "أخرى"], required: true },
      { key: "smartFeatures", label: "المميزات الذكية", type: "select", options: ["سمارت", "غير سمارت", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "OLED TV": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Sony", "TCL", "Hisense", "Toshiba", "Panasonic", "Philips", "أخرى"], required: true },
      { key: "screenSize", label: "حجم الشاشة (بوصة)", type: "select", options: ["42", "48", "55", "65", "77", "83", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["4K", "8K", "أخرى"], required: true },
      { key: "smartFeatures", label: "المميزات الذكية", type: "select", options: ["سمارت", "Android TV", "WebOS", "Tizen", "Google TV", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "أنظمة الصوت": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["JBL", "Sony", "Bose", "Harman Kardon", "Samsung", "LG", "Marshall", "أخرى"], required: true },
      { key: "soundType", label: "النوع", type: "select", options: ["سلكي", "لاسلكي", "بلوتوث", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "ساوند بار": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["JBL", "Sony", "Bose", "Samsung", "LG", "Sonos", "Yamaha", "أخرى"], required: true },
      { key: "soundType", label: "النوع", type: "select", options: ["سلكي", "لاسلكي", "بلوتوث", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "سماعات رأس": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Apple", "Samsung", "Sony", "JBL", "Bose", "Beats", "Sennheiser", "Audio-Technica", "أخرى"], required: true },
      { key: "headphoneType", label: "النوع", type: "select", options: ["سلكية", "لاسلكية", "بلوتوث", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كاميرا": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Canon", "Nikon", "Sony", "Fujifilm", "Panasonic", "Olympus", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "sensorType", label: "نوع الحساس", type: "select", options: ["Full Frame", "APS-C", "Micro Four Thirds", "أخرى"] },
      { key: "megapixels", label: "الميجابكسل", type: "select", options: ["12", "16", "20", "24", "26", "30", "45", "50", "60", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كاميرا احترافية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Canon", "Nikon", "Sony", "Fujifilm", "Panasonic", "Leica", "Hasselblad", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "sensorType", label: "نوع الحساس", type: "select", options: ["Full Frame", "Medium Format", "APS-C", "أخرى"] },
      { key: "megapixels", label: "الميجابكسل", type: "select", options: ["20", "24", "30", "45", "50", "60", "100", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "عدسات": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Canon", "Nikon", "Sony", "Sigma", "Tamron", "Fujifilm", "أخرى"], required: true },
      { key: "model", label: "الموديل", type: "text", required: true },
      { key: "focalLength", label: "البعد البؤري (mm)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كاميرا فيديو": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Canon", "Sony", "Panasonic", "Blackmagic", "JVC", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["Full HD", "4K", "6K", "8K", "أخرى"], required: true },
      { key: "batteryLife", label: "عمر البطارية (ساعة)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "درون": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["DJI", "Autel", "Parrot", "Holy Stone", "أخرى"], required: true },
      { key: "resolution", label: "دقة الكاميرا", type: "select", options: ["1080p", "2.7K", "4K", "5.4K", "أخرى"], required: true },
      { key: "batteryLife", label: "عمر البطارية (دقيقة)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كاميرا أكشن": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["GoPro", "DJI", "Insta360", "Akaso", "أخرى"], required: true },
      { key: "resolution", label: "الدقة", type: "select", options: ["1080p", "2.7K", "4K", "5.3K", "أخرى"], required: true },
      { key: "batteryLife", label: "عمر البطارية (دقيقة)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "بلايستيشن": {
    fields: [
      { key: "model", label: "الموديل/الجيل", type: "select", options: ["PS5", "PS5 Digital", "PS4 Pro", "PS4 Slim", "PS4", "PS3", "PS Vita", "أخرى"], required: true },
      { key: "storageCapacity", label: "سعة التخزين", type: "select", options: ["500GB", "825GB", "1TB", "2TB", "أخرى"] },
      { key: "controllers", label: "عدد الأيادي", type: "select", options: ["1", "2", "3", "4", "بدون"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "إكس بوكس": {
    fields: [
      { key: "model", label: "الموديل/الجيل", type: "select", options: ["Xbox Series X", "Xbox Series S", "Xbox One X", "Xbox One S", "Xbox One", "Xbox 360", "أخرى"], required: true },
      { key: "storageCapacity", label: "سعة التخزين", type: "select", options: ["500GB", "1TB", "2TB", "أخرى"] },
      { key: "controllers", label: "عدد الأيادي", type: "select", options: ["1", "2", "3", "4", "بدون"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "نينتندو": {
    fields: [
      { key: "model", label: "الموديل/الجيل", type: "select", options: ["Nintendo Switch OLED", "Nintendo Switch", "Nintendo Switch Lite", "Nintendo 3DS", "Wii U", "أخرى"], required: true },
      { key: "storageCapacity", label: "سعة التخزين", type: "select", options: ["32GB", "64GB", "أخرى"] },
      { key: "controllers", label: "عدد الأيادي", type: "select", options: ["1", "2", "3", "4", "بدون"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },

  // ==================== SHOPPING - HOME APPLIANCES (LARGE) ====================
  "ثلاجة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Hitachi", "Toshiba", "Sharp", "Beko", "Arcelik", "Haier", "أخرى"], required: true },
      { key: "capacity", label: "السعة (لتر)", type: "select", options: ["150", "200", "250", "300", "350", "400", "450", "500", "550", "600+", "أخرى"] },
      { key: "fridgeType", label: "النوع", type: "select", options: ["باب واحد", "بابين", "جنب بجنب (Side by Side)", "فرنسي", "أخرى"], required: true },
      { key: "energyRating", label: "تصنيف الطاقة", type: "select", options: ["A+++", "A++", "A+", "A", "B", "C", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "فضي", "أسود", "ستانلس ستيل", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "غسالة ملابس": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Beko", "Arcelik", "Bosch", "Siemens", "Haier", "Hitachi", "أخرى"], required: true },
      { key: "capacity", label: "السعة (كغ)", type: "select", options: ["5", "6", "7", "8", "9", "10", "12", "14", "أخرى"], required: true },
      { key: "washerType", label: "النوع", type: "select", options: ["تحميل أمامي", "تحميل علوي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "غسالة صحون": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Bosch", "Siemens", "Samsung", "LG", "Beko", "Arcelik", "أخرى"], required: true },
      { key: "capacity", label: "السعة (أطقم)", type: "select", options: ["6", "8", "10", "12", "14", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مجففة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Bosch", "Siemens", "Beko", "أخرى"], required: true },
      { key: "capacity", label: "السعة (كغ)", type: "select", options: ["5", "6", "7", "8", "9", "10", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "فرن": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Bosch", "Siemens", "Samsung", "LG", "Beko", "Arcelik", "أخرى"], required: true },
      { key: "ovenType", label: "النوع", type: "select", options: ["غاز", "كهربائي", "غاز + كهربائي", "أخرى"], required: true },
      { key: "burners", label: "عدد العيون", type: "select", options: ["2", "3", "4", "5", "6", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "طباخ": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Bosch", "Siemens", "Samsung", "LG", "Beko", "Arcelik", "أخرى"], required: true },
      { key: "ovenType", label: "النوع", type: "select", options: ["غاز", "كهربائي", "غاز + كهربائي", "أخرى"], required: true },
      { key: "burners", label: "عدد العيون", type: "select", options: ["2", "3", "4", "5", "6", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "شفاط": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Bosch", "Siemens", "Samsung", "Beko", "Elica", "Franke", "أخرى"], required: true },
      { key: "hoodType", label: "النوع", type: "select", options: ["جداري", "مدمج", "جزيرة", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مايكروويف": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Panasonic", "Sharp", "Toshiba", "Bosch", "أخرى"], required: true },
      { key: "capacity", label: "السعة (لتر)", type: "select", options: ["20", "23", "25", "28", "30", "32", "40", "أخرى"] },
      { key: "power", label: "القدرة (واط)", type: "select", options: ["700", "800", "900", "1000", "1100", "1200", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "فريزر": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Hitachi", "Beko", "Haier", "أخرى"], required: true },
      { key: "capacity", label: "السعة (لتر)", type: "select", options: ["100", "150", "200", "250", "300", "350", "400", "500+", "أخرى"] },
      { key: "freezerType", label: "النوع", type: "select", options: ["أفقي (صندوق)", "عمودي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مكيف": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Samsung", "LG", "Gree", "Daikin", "Carrier", "Midea", "TCL", "Haier", "أخرى"], required: true },
      { key: "capacity", label: "السعة (طن/BTU)", type: "select", options: ["1 طن", "1.5 طن", "2 طن", "2.5 طن", "3 طن", "12000 BTU", "18000 BTU", "24000 BTU", "أخرى"], required: true },
      { key: "acType", label: "النوع", type: "select", options: ["سبلت", "شباك", "متنقل", "مركزي", "كاسيت", "أخرى"], required: true },
      { key: "energyRating", label: "تصنيف الطاقة", type: "select", options: ["A+++", "A++", "A+", "A", "B", "C", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مكنسة كهربائية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Dyson", "Samsung", "LG", "Philips", "Bosch", "Miele", "Electrolux", "أخرى"], required: true },
      { key: "vacuumType", label: "النوع", type: "select", options: ["عمودية", "أسطوانية", "محمولة", "لاسلكية", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مكنسة روبوت": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["iRobot", "Roborock", "Xiaomi", "Ecovacs", "Samsung", "Dreame", "أخرى"], required: true },
      { key: "vacuumType", label: "النوع", type: "select", options: ["كنس فقط", "كنس ومسح", "أخرى"] },
      { key: "power", label: "قوة الشفط (Pa)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },

  // ==================== SHOPPING - SMALL APPLIANCES ====================
  "ماكينة قهوة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nespresso", "De'Longhi", "Breville", "Philips", "Krups", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "غلاية شاي": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Philips", "Bosch", "Tefal", "Kenwood", "Braun", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "توستر": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Philips", "Tefal", "Kenwood", "Black+Decker", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "خلاط": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Philips", "Braun", "Kenwood", "Moulinex", "Tefal", "Ninja", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مكواة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Philips", "Tefal", "Braun", "Bosch", "Rowenta", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مجفف شعر": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Dyson", "Philips", "Braun", "BaByliss", "Panasonic", "Remington", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "محمصة خبز": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Philips", "Tefal", "Kenwood", "Black+Decker", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كاتل": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Philips", "Bosch", "Tefal", "Kenwood", "Braun", "أخرى"], required: true },
      { key: "power", label: "القدرة (واط)", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },

  // ==================== SHOPPING - WOMEN'S CLOTHING ====================
  "ملابس نسائية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخضر", "وردي", "بنفسجي", "بيج", "رمادي", "بني", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "حرير", "كتان", "صوف", "جينز", "شيفون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "فساتين": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخضر", "وردي", "بنفسجي", "بيج", "رمادي", "بني", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "حرير", "كتان", "صوف", "شيفون", "ستان", "دانتيل", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "بلوزات": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخضر", "وردي", "بنفسجي", "بيج", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "حرير", "كتان", "شيفون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "قمصان": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخضر", "وردي", "بنفسجي", "بيج", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "حرير", "كتان", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "تيشرتات": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخضر", "وردي", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "بناطيل": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "جينز", "بوليستر", "كتان", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "تنانير": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "وردي", "بيج", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "حرير", "جينز", "شيفون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "شورتات": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "بيج", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "جينز", "بوليستر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "جواكت": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "جلد", "بوليستر", "صوف", "نايلون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "معاطف": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["صوف", "كشمير", "بوليستر", "جلد", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية نسائية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "بيج", "بني", "وردي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كعب عالي": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "بيج", "ذهبي", "فضي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية رياضية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "New Balance", "Reebok", "Skechers", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "بوت": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "بني", "بيج", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "صنادل": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "بيج", "بني", "ذهبي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "حقائب نسائية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "بيج", "بني", "وردي", "أخرى"] },
      { key: "material", label: "الخامة", type: "select", options: ["جلد طبيعي", "جلد صناعي", "قماش", "نايلون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "شنط يد": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "بيج", "بني", "وردي", "أخرى"] },
      { key: "material", label: "الخامة", type: "select", options: ["جلد طبيعي", "جلد صناعي", "قماش", "نايلون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "شنط كتف": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "بيج", "بني", "وردي", "أخرى"] },
      { key: "material", label: "الخامة", type: "select", options: ["جلد طبيعي", "جلد صناعي", "قماش", "نايلون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - MEN'S CLOTHING ====================
  "ملابس رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "كتان", "صوف", "جينز", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "قمصان رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "بيج", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "كتان", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "تيشرتات رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "بوليستر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "بناطيل رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "جينز", "بوليستر", "كتان", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "بدلات": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "كحلي", "رمادي", "أزرق", "بني", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["صوف", "بوليستر", "قطن", "كتان", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "جواكت رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أزرق", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["جلد", "قطن", "بوليستر", "صوف", "نايلون", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "معاطف رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "رمادي", "بيج", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["صوف", "كشمير", "بوليستر", "جلد", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "بني", "رمادي", "أبيض", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية كلاسيك": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "بني", "كحلي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية رياضية رجالية": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "رمادي", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "New Balance", "Reebok", "Skechers", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - CHILDREN'S CLOTHING ====================
  "ملابس أطفال": {
    fields: [
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["0-6 أشهر", "6-12 شهر", "1-2 سنة", "2-3 سنوات", "3-4 سنوات", "4-6 سنوات", "6-8 سنوات", "8-10 سنوات", "10-12 سنة", "12-14 سنة", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "وردي", "أخضر", "أصفر", "أخرى"] },
      { key: "gender", label: "الجنس", type: "select", options: ["ولادي", "بناتي", "للجنسين", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس رضع": {
    fields: [
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["حديث الولادة", "0-3 أشهر", "3-6 أشهر", "6-9 أشهر", "9-12 شهر", "12-18 شهر", "18-24 شهر", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "وردي", "أزرق", "أصفر", "أخضر", "أخرى"] },
      { key: "gender", label: "الجنس", type: "select", options: ["ولادي", "بناتي", "للجنسين", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية أطفال": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "وردي", "أخرى"] },
      { key: "gender", label: "الجنس", type: "select", options: ["ولادي", "بناتي", "للجنسين", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - ACCESSORIES ====================
  "ساعات": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Rolex", "Omega", "Casio", "Seiko", "Citizen", "Tissot", "Apple", "Samsung", "Huawei", "Xiaomi", "أخرى"], required: true },
      { key: "watchType", label: "النوع", type: "select", options: ["أنالوج", "رقمي", "ذكية", "أخرى"], required: true },
      { key: "gender", label: "الجنس", type: "select", options: ["رجالي", "نسائي", "للجنسين", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "فضي", "ذهبي", "أبيض", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "ساعات جدارية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "wallClockType", label: "النوع", type: "select", options: ["كلاسيكية", "عصرية", "خشبية", "معدنية", "بندول", "رقمية", "أخرى"], required: true },
      { key: "size", label: "الحجم", type: "select", options: ["صغيرة (أقل من 30 سم)", "متوسطة (30-50 سم)", "كبيرة (أكثر من 50 سم)", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "ذهبي", "فضي", "خشبي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "نظارات": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Ray-Ban", "Oakley", "Gucci", "Prada", "Versace", "Dior", "أخرى"] },
      { key: "glassType", label: "النوع", type: "select", options: ["طبية", "شمسية", "أخرى"], required: true },
      { key: "gender", label: "الجنس", type: "select", options: ["رجالي", "نسائي", "للجنسين", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "نظارات شمسية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Ray-Ban", "Oakley", "Gucci", "Prada", "Versace", "Dior", "Maui Jim", "أخرى"] },
      { key: "gender", label: "الجنس", type: "select", options: ["رجالي", "نسائي", "للجنسين", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحزمة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "بني", "أخرى"] },
      { key: "material", label: "الخامة", type: "select", options: ["جلد طبيعي", "جلد صناعي", "قماش", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "محافظ": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "بني", "كحلي", "أخرى"] },
      { key: "material", label: "الخامة", type: "select", options: ["جلد طبيعي", "جلد صناعي", "قماش", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أوشحة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "رمادي", "بيج", "أخرى"] },
      { key: "material", label: "الخامة", type: "select", options: ["حرير", "صوف", "كشمير", "قطن", "بوليستر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - FURNITURE ====================
  "أثاث": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب زان", "خشب أرو", "MDF", "خشب صنوبر", "خشب جوز", "معدن", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "بيج", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أثاث منزلي": {
    fields: [
      { key: "furnitureType", label: "نوع الأثاث", type: "select", options: ["غرفة نوم", "غرفة معيشة", "غرفة طعام", "مكتب", "مطبخ", "حمام", "أخرى"], required: true },
      { key: "material", label: "الخامة", type: "select", options: ["خشب زان", "خشب أرو", "MDF", "خشب صنوبر", "خشب جوز", "معدن", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "بيج", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "طقم كنب": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["قماش", "جلد طبيعي", "جلد صناعي", "مخمل", "كتان", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "بيج", "رمادي", "أزرق", "أخرى"] },
      { key: "dimensions", label: "الأبعاد / عدد المقاعد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "غرفة طعام": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب زان", "خشب أرو", "MDF", "خشب جوز", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بني", "بيج", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "عدد المقاعد", type: "select", options: ["4", "6", "8", "10", "12", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "غرفة نوم": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب زان", "خشب أرو", "MDF", "خشب جوز", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بني", "بيج", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كنب": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["قماش", "جلد طبيعي", "جلد صناعي", "مخمل", "كتان", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "بيج", "رمادي", "أزرق", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "طاولة": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب", "MDF", "زجاج", "رخام", "معدن", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "بيج", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كرسي": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب", "معدن", "بلاستيك", "قماش", "جلد", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "رمادي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "دولاب": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب زان", "خشب أرو", "MDF", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بني", "بيج", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد / عدد الأبواب", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "مكتبة": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب", "MDF", "معدن", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بني", "بيج", "أسود", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "طاولة تلفزيون": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب", "MDF", "زجاج", "معدن", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "بني", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد", type: "text" },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "سرير": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب زان", "خشب أرو", "MDF", "معدن", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بني", "بيج", "رمادي", "خشبي طبيعي", "أخرى"] },
      { key: "dimensions", label: "المقاس", type: "select", options: ["فردي (90×200)", "فردي ونصف (120×200)", "مزدوج (140×200)", "كوين (160×200)", "كينج (180×200)", "سوبر كينج (200×200)", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "قاعدة سرير": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["خشب", "معدن", "قماش", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بني", "بيج", "رمادي", "أخرى"] },
      { key: "dimensions", label: "المقاس", type: "select", options: ["فردي (90×200)", "فردي ونصف (120×200)", "مزدوج (140×200)", "كوين (160×200)", "كينج (180×200)", "سوبر كينج (200×200)", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "مرتبة": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["سبرنج", "ميموري فوم", "لاتكس", "طبية", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "رمادي", "أخرى"] },
      { key: "dimensions", label: "المقاس", type: "select", options: ["فردي (90×200)", "فردي ونصف (120×200)", "مزدوج (140×200)", "كوين (160×200)", "كينج (180×200)", "سوبر كينج (200×200)", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "مفارش": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["قطن", "حرير", "ستان", "مايكروفايبر", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بيج", "رمادي", "أزرق", "وردي", "أخرى"] },
      { key: "dimensions", label: "المقاس", type: "select", options: ["فردي", "مزدوج", "كوين", "كينج", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "إضاءة": {
    fields: [
      { key: "lightType", label: "النوع", type: "select", options: ["ثريا", "لمبة سقف", "أباجورة", "إضاءة حائط", "إضاءة أرضية", "LED", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "ذهبي", "فضي", "أسود", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ثريا": {
    fields: [
      { key: "lightType", label: "النوع", type: "select", options: ["كريستال", "معدن", "خشب", "حديثة", "كلاسيكية", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["ذهبي", "فضي", "أسود", "أبيض", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "لمبات": {
    fields: [
      { key: "lightType", label: "النوع", type: "select", options: ["LED", "فلورسنت", "هالوجين", "ذكية", "أخرى"] },
      { key: "color", label: "لون الإضاءة", type: "select", options: ["أبيض بارد", "أبيض دافئ", "أصفر", "متعدد الألوان", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أباجورة": {
    fields: [
      { key: "lightType", label: "النوع", type: "select", options: ["طاولة", "أرضية", "حائط", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "أسود", "ذهبي", "فضي", "خشبي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "سجاد": {
    fields: [
      { key: "carpetSize", label: "المقاس", type: "select", options: ["1×1.5 م", "1.5×2 م", "2×3 م", "2.5×3.5 م", "3×4 م", "3×5 م", "4×6 م", "أخرى"], required: true },
      { key: "material", label: "الخامة", type: "select", options: ["صوف", "حرير", "بوليستر", "قطن", "نايلون", "أخرى"] },
      { key: "origin", label: "بلد المنشأ", type: "select", options: ["إيراني", "تركي", "صيني", "باكستاني", "هندي", "أفغاني", "أخرى"] },
      { key: "color", label: "اللون الرئيسي", type: "select", options: ["أحمر", "أزرق", "بيج", "رمادي", "أخضر", "بني", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ستائر": {
    fields: [
      { key: "curtainSize", label: "المقاس", type: "text" },
      { key: "material", label: "الخامة", type: "select", options: ["قماش", "حرير", "كتان", "بوليستر", "مخمل", "تول", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "بيج", "رمادي", "أخضر", "أزرق", "بني", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ديكور": {
    fields: [
      { key: "decorType", label: "النوع", type: "select", options: ["لوحات", "مرايا", "تحف", "مزهريات", "ساعات حائط", "إطارات", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["ذهبي", "فضي", "أبيض", "أسود", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "لوحات فنية": {
    fields: [
      { key: "artStyle", label: "الأسلوب الفني", type: "select", options: ["تجريدي", "واقعي", "كلاسيكي", "حديث", "إسلامي وخط عربي", "طبيعة صامتة", "بورتريه", "مناظر طبيعية", "أخرى"], required: true },
      { key: "medium", label: "التقنية / الخامة", type: "select", options: ["زيت على قماش", "أكريليك", "مائي", "فحم", "رصاص", "طباعة فنية", "رقمي", "أخرى"] },
      { key: "dimensions", label: "الأبعاد (سم)", type: "text" },
      { key: "artist", label: "اسم الفنان", type: "text" },
      { key: "isOriginal", label: "هل هي أصلية؟", type: "select", options: ["أصلية", "نسخة محدودة", "مطبوعة"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديدة", "ممتازة", "جيدة جداً", "جيدة", "أخرى"], required: true },
    ]
  },
  "أدوات مطبخ": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["ستانلس ستيل", "ألومنيوم", "سيراميك", "جرانيت", "تيفال", "زجاج", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "pieces", label: "عدد القطع", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "قدور": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["ستانلس ستيل", "ألومنيوم", "جرانيت", "سيراميك", "نحاس", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "pieces", label: "عدد القطع", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "مقالي": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["تيفال", "ستانلس ستيل", "جرانيت", "سيراميك", "حديد زهر", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "pieces", label: "عدد القطع", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "صحون": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["بورسلين", "سيراميك", "زجاج", "ميلامين", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "pieces", label: "عدد القطع", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أكواب": {
    fields: [
      { key: "material", label: "الخامة", type: "select", options: ["بورسلين", "سيراميك", "زجاج", "ستانلس ستيل", "أخرى"] },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "pieces", label: "عدد القطع", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - GARDEN ====================
  "أثاث حديقة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "gardenType", label: "النوع", type: "select", options: ["طقم جلوس", "طاولة", "كرسي", "مظلة", "أرجوحة", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أدوات الحديقة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "gardenToolType", label: "النوع", type: "select", options: ["مقص تقليم", "رشاش", "خرطوم", "مجرفة", "أداة حفر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ماكينة قص العشب": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Bosch", "Husqvarna", "Honda", "Makita", "Stihl", "أخرى"] },
      { key: "mowerType", label: "النوع", type: "select", options: ["كهربائي", "بنزين", "بطارية", "يدوي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - SPORTS EQUIPMENT ====================
  "معدات رياضية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "equipmentType", label: "النوع", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "أجهزة لياقة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Life Fitness", "Technogym", "NordicTrack", "ProForm", "Sole", "أخرى"] },
      { key: "fitnessType", label: "النوع", type: "select", options: ["مشاية", "دراجة ثابتة", "إليبتيكال", "رولنج", "جهاز متعدد", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مشاية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["NordicTrack", "ProForm", "Sole", "Life Fitness", "Horizon", "أخرى"] },
      { key: "treadmillType", label: "النوع", type: "select", options: ["كهربائية", "يدوية", "قابلة للطي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "دراجة ثابتة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["NordicTrack", "Schwinn", "Peloton", "Life Fitness", "Keiser", "أخرى"] },
      { key: "bikeType", label: "النوع", type: "select", options: ["عمودية", "أفقية", "سبين", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "دراجة هوائية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Trek", "Giant", "Specialized", "Cannondale", "Scott", "Merida", "أخرى"], required: true },
      { key: "frameSize", label: "حجم الإطار", type: "select", options: ["XS", "S", "M", "L", "XL", "أخرى"] },
      { key: "wheelSize", label: "حجم العجلة (بوصة)", type: "select", options: ["20", "24", "26", "27.5", "29", "700C", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "دراجة جبلية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Trek", "Giant", "Specialized", "Cannondale", "Scott", "Santa Cruz", "أخرى"], required: true },
      { key: "frameSize", label: "حجم الإطار", type: "select", options: ["XS", "S", "M", "L", "XL", "أخرى"] },
      { key: "wheelSize", label: "حجم العجلة (بوصة)", type: "select", options: ["26", "27.5", "29", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - HOBBIES & MISC ====================
  "معدات تخييم": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "campingType", label: "النوع", type: "select", options: ["خيمة", "كيس نوم", "كرسي تخييم", "طاولة تخييم", "مصباح", "موقد", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "خيمة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "tentCapacity", label: "السعة (أشخاص)", type: "select", options: ["1", "2", "3", "4", "6", "8", "10+", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كيس نوم": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "tempRating", label: "تحمل الحرارة", type: "select", options: ["صيفي (15°+)", "3 مواسم (0° إلى 15°)", "شتوي (-10° إلى 0°)", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "آلات موسيقية": {
    fields: [
      { key: "instrumentType", label: "النوع", type: "select", options: ["جيتار", "بيانو", "أورج", "كمان", "درامز", "عود", "ناي", "أخرى"], required: true },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "جيتار": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Fender", "Gibson", "Yamaha", "Ibanez", "Taylor", "Martin", "Epiphone", "أخرى"], required: true },
      { key: "guitarType", label: "النوع", type: "select", options: ["أكوستيك", "كلاسيك", "كهربائي", "بيس", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "بيانو": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Yamaha", "Kawai", "Steinway", "Roland", "Casio", "Korg", "أخرى"], required: true },
      { key: "pianoType", label: "النوع", type: "select", options: ["أكوستيك", "رقمي", "جراند", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أورج": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Yamaha", "Casio", "Korg", "Roland", "أخرى"], required: true },
      { key: "keys", label: "عدد المفاتيح", type: "select", options: ["49", "61", "76", "88", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كمان": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "violinSize", label: "الحجم", type: "select", options: ["1/4", "1/2", "3/4", "4/4 (كامل)", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "درامز": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Pearl", "Yamaha", "Roland", "DW", "Tama", "Ludwig", "أخرى"], required: true },
      { key: "drumType", label: "النوع", type: "select", options: ["أكوستيك", "إلكتروني", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SHOPPING - MOTHER & BABY ====================
  "عربة أطفال": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Chicco", "Graco", "Joie", "Maxi-Cosi", "Bugaboo", "Stokke", "أخرى"], required: true },
      { key: "strollerType", label: "النوع", type: "select", options: ["خفيفة", "مزدوجة", "ثلاثية العجلات", "نظام سفر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "سرير أطفال": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "cribType", label: "النوع", type: "select", options: ["سرير رضع", "سرير أطفال", "سرير قابل للتحويل", "سرير سفر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كرسي طعام": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كرسي سيارة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Chicco", "Graco", "Joie", "Maxi-Cosi", "Britax", "Cybex", "أخرى"], required: true },
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["0-13 كغ (مجموعة 0+)", "9-18 كغ (مجموعة 1)", "15-36 كغ (مجموعة 2-3)", "0-36 كغ (شامل)", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SPORTS (riyada) ====================
  "أحذية كرة قدم": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "New Balance", "Mizuno", "Under Armour", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية جري": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Asics", "New Balance", "Brooks", "Saucony", "Hoka", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية كرة سلة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Jordan", "Under Armour", "Puma", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس رياضية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "Under Armour", "Reebok", "أخرى"] },
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أحمر", "أزرق", "رمادي", "أخرى"] },
      { key: "gender", label: "الجنس", type: "select", options: ["رجالي", "نسائي", "للجنسين", "أطفال", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس تدريب": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "Under Armour", "Gymshark", "أخرى"] },
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "رمادي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس سباحة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Speedo", "Arena", "Nike", "Adidas", "TYR", "أخرى"] },
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "أخرى"], required: true },
      { key: "gender", label: "الجنس", type: "select", options: ["رجالي", "نسائي", "أطفال", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس رياضية نسائية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "Under Armour", "Lululemon", "أخرى"] },
      { key: "size", label: "المقاس", type: "select", options: ["XS", "S", "M", "L", "XL", "2XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "وردي", "أزرق", "رمادي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس رياضية رجالية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "Under Armour", "Reebok", "أخرى"] },
      { key: "size", label: "المقاس", type: "select", options: ["S", "M", "L", "XL", "2XL", "3XL", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "رمادي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس رياضية أطفال": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "أخرى"] },
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["2-4 سنوات", "4-6 سنوات", "6-8 سنوات", "8-10 سنوات", "10-12 سنة", "12-14 سنة", "أخرى"], required: true },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "معدات كمال الأجسام": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "equipmentType", label: "النوع", type: "select", options: ["أوزان حديدية", "بار حديد", "كيتل بل", "دامبلز", "جهاز متعدد", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== CHILDREN (atfal) ====================
  "ملابس أولاد": {
    fields: [
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["2-3 سنوات", "3-4 سنوات", "4-6 سنوات", "6-8 سنوات", "8-10 سنوات", "10-12 سنة", "12-14 سنة", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخضر", "رمادي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس بنات": {
    fields: [
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["2-3 سنوات", "3-4 سنوات", "4-6 سنوات", "6-8 سنوات", "8-10 سنوات", "10-12 سنة", "12-14 سنة", "أخرى"], required: true },
      { key: "size", label: "المقاس", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["وردي", "أبيض", "أحمر", "أزرق", "بنفسجي", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ملابس رضع (0-2 سنة)": {
    fields: [
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["حديث الولادة", "0-3 أشهر", "3-6 أشهر", "6-9 أشهر", "9-12 شهر", "12-18 شهر", "18-24 شهر", "أخرى"], required: true },
      { key: "gender", label: "الجنس", type: "select", options: ["ولادي", "بناتي", "للجنسين", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أبيض", "وردي", "أزرق", "أصفر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية أولاد": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية بنات": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "color", label: "اللون", type: "select", options: ["وردي", "أبيض", "أسود", "أحمر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "أحذية رياضية أطفال": {
    fields: [
      { key: "size", label: "المقاس", type: "select", options: ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "أخرى"], required: true },
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Nike", "Adidas", "Puma", "New Balance", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أسود", "أبيض", "أزرق", "أحمر", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "كرسي سيارة أطفال": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Chicco", "Graco", "Joie", "Maxi-Cosi", "Britax", "Cybex", "أخرى"], required: true },
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["0-13 كغ (مجموعة 0+)", "9-18 كغ (مجموعة 1)", "15-36 كغ (مجموعة 2-3)", "0-36 كغ (شامل)", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "دراجات أطفال": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "wheelSize", label: "حجم العجلة (بوصة)", type: "select", options: ["12", "14", "16", "18", "20", "24", "أخرى"], required: true },
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["2-4 سنوات", "4-6 سنوات", "6-8 سنوات", "8-10 سنوات", "10-12 سنة", "أخرى"] },
      { key: "color", label: "اللون", type: "select", options: ["أحمر", "أزرق", "وردي", "أسود", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "ألعاب تعليمية": {
    fields: [
      { key: "ageGroup", label: "الفئة العمرية", type: "select", options: ["0-1 سنة", "1-3 سنوات", "3-6 سنوات", "6-9 سنوات", "9-12 سنة", "أخرى"], required: true },
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== MEDICAL (tibbi) ====================
  "أجهزة قياس ضغط الدم": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Omron", "Beurer", "Braun", "Microlife", "أخرى"], required: true },
      { key: "deviceType", label: "النوع", type: "select", options: ["رقمي ذراع", "رقمي معصم", "زئبقي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "أجهزة قياس السكر": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Accu-Chek", "OneTouch", "FreeStyle", "Contour", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "كراسي متحركة": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "wheelchairType", label: "النوع", type: "select", options: ["يدوي", "كهربائي", "خفيف الوزن", "رياضي", "أطفال", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "مكثفات أكسجين": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "flowRate", label: "معدل التدفق (لتر/دقيقة)", type: "select", options: ["1", "2", "3", "5", "8", "10", "أخرى"], required: true },
      { key: "oxygenType", label: "النوع", type: "select", options: ["ثابت", "محمول", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "أسرة مستشفيات": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "bedType", label: "النوع", type: "select", options: ["يدوي", "كهربائي", "شبه كهربائي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "أسرة رعاية منزلية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "bedType", label: "النوع", type: "select", options: ["يدوي", "كهربائي", "شبه كهربائي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "نظارات طبية": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "gender", label: "الجنس", type: "select", options: ["رجالي", "نسائي", "للجنسين", "أطفال", "أخرى"] },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },

  // ==================== SPARE PARTS (yedek-parca) ====================
  "قطع المحرك": {
    fields: [
      { key: "compatibleBrand", label: "متوافق مع", type: "text", required: true },
      { key: "compatibleModel", label: "الموديل المتوافق", type: "text" },
      { key: "partOrigin", label: "المنشأ", type: "select", options: ["أصلي (OEM)", "بديل جودة عالية", "بديل", "مستعمل أصلي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "قطع ناقل الحركة": {
    fields: [
      { key: "compatibleBrand", label: "متوافق مع", type: "text", required: true },
      { key: "compatibleModel", label: "الموديل المتوافق", type: "text" },
      { key: "partOrigin", label: "المنشأ", type: "select", options: ["أصلي (OEM)", "بديل جودة عالية", "بديل", "مستعمل أصلي", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
      { key: "warranty", label: "الضمان", type: "select", options: ["يوجد ضمان", "لا يوجد ضمان", "أخرى"] },
    ]
  },
  "إطارات": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Michelin", "Bridgestone", "Continental", "Goodyear", "Pirelli", "Hankook", "Yokohama", "Dunlop", "أخرى"], required: true },
      { key: "tireSize", label: "المقاس", type: "text", required: true },
      { key: "tireType", label: "النوع", type: "select", options: ["صيفي", "شتوي", "4 مواسم", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "جنوط": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "text" },
      { key: "rimSize", label: "المقاس (بوصة)", type: "select", options: ["14", "15", "16", "17", "18", "19", "20", "21", "22", "أخرى"], required: true },
      { key: "rimMaterial", label: "الخامة", type: "select", options: ["ألومنيوم", "حديد", "كربون فايبر", "أخرى"], required: true },
      { key: "condition", label: "الحالة", type: "select", options: ["جديد", "مستعمل - ممتاز", "مستعمل - جيد جداً", "مستعمل - جيد", "أخرى"], required: true },
    ]
  },
  "زيت المحرك": {
    fields: [
      { key: "brand", label: "العلامة التجارية", type: "select", options: ["Mobil", "Castrol", "Shell", "Total", "Valvoline", "Motul", "Liqui Moly", "أخرى"], required: true },
      { key: "viscosity", label: "اللزوجة", type: "select", options: ["5W-20", "5W-30", "5W-40", "10W-30", "10W-40", "15W-40", "20W-50", "0W-20", "أخرى"], required: true },
      { key: "oilType", label: "النوع", type: "select", options: ["تخليقي كامل", "شبه تخليقي", "معدني", "أخرى"], required: true },
      { key: "capacity", label: "الحجم (لتر)", type: "select", options: ["1", "4", "5", "20", "أخرى"] },
    ]
  }
};

export const MAX_DROPSHIPPING_PRODUCTS = 20;

export const DROPSHIPPING_MARGIN = {
  THRESHOLD_IQD: 150_000,
  LOW_TIER_MULTIPLIER: 1.10,
  HIGH_TIER_MULTIPLIER: 1.05,
  USD_TO_IQD_RATE: 1_500,
};

export interface DropshippingMarginSettings {
  thresholdIQD?: number;
  lowTierPercent?: number;
  highTierPercent?: number;
}

export function calcMinResalePrice(
  wholesalePrice: number,
  currency: string = "IQD",
  overrides?: DropshippingMarginSettings
): {
  minPrice: number;
  marginPercent: number;
} {
  const threshold = overrides?.thresholdIQD ?? DROPSHIPPING_MARGIN.THRESHOLD_IQD;
  const lowPercent = overrides?.lowTierPercent ?? Math.round((DROPSHIPPING_MARGIN.LOW_TIER_MULTIPLIER - 1) * 100);
  const highPercent = overrides?.highTierPercent ?? Math.round((DROPSHIPPING_MARGIN.HIGH_TIER_MULTIPLIER - 1) * 100);

  const priceInIQD = currency === "USD"
    ? wholesalePrice * DROPSHIPPING_MARGIN.USD_TO_IQD_RATE
    : wholesalePrice;

  const marginPercent = priceInIQD < threshold ? lowPercent : highPercent;
  const minPrice = Math.ceil(wholesalePrice * marginPercent / 100) + wholesalePrice;

  return { minPrice, marginPercent };
}

export const SEARCH_ALIASES: Record<string, string[]> = {
  "اكسسوارات موبايل":    ["إكسسوارات الهاتف"],
  "اكسسوارات الموبايل":  ["إكسسوارات الهاتف"],
  "ملحقات موبايل":       ["إكسسوارات الهاتف"],
  "ملحقات الموبايل":     ["إكسسوارات الهاتف"],
  "ملحقات هاتف":         ["إكسسوارات الهاتف"],
  "ملحقات الهاتف":       ["إكسسوارات الهاتف"],
};

// Map legacy subcategory names (saved in older listings/products) to the
// current canonical name used by the hierarchy/constants/inputs. Keep this
// table as small as possible — it is only meant to keep counts/filters
// consistent for old data without a mass migration.
export const SUBCATEGORY_ALIASES: Record<string, string> = {
  // Saloon cars path: unify "سيارة خصوصي" / "سيارة" → "سيارة صالون"
  "سيارة خصوصي": "سيارة صالون",
  "سيارة": "سيارة صالون",
};

// Returns the canonical subcategory name for a (possibly legacy) value.
export function canonicalizeSubcategory<T extends string | null | undefined>(name: T): T {
  if (!name) return name;
  const mapped = SUBCATEGORY_ALIASES[name as string];
  return (mapped ?? name) as T;
}

// Returns the legacy alias names that all map to the given canonical name.
export function getSubcategoryAliases(canonical: string): string[] {
  const out: string[] = [];
  for (const [legacy, c] of Object.entries(SUBCATEGORY_ALIASES)) {
    if (c === canonical && legacy !== canonical) out.push(legacy);
  }
  return out;
}
